// Capture Swiper 11 reference before vendor.min.js overrides it with Swiper 4
const SwiperV11 = window.Swiper;

var Shopify = Shopify || {};
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var moneySettings = window.peggellMoney || {};
  var formatString = format || moneySettings.moneyFormat || (window.theme && theme.moneyFormat) || '${{amount}}';

  if (!format && moneySettings.currency && moneySettings.locale) {
    var amount = Number(cents) / 100;
    if (!Number.isNaN(amount)) {
      try {
        var intlFormatted = new Intl.NumberFormat(moneySettings.locale, {
          style: 'currency',
          currency: moneySettings.currency,
          currencyDisplay: 'symbol'
        }).format(amount);

        return intlFormatted;
      } catch (error) {
        // Fall back to Shopify money format string below.
      }
    }
  }

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsPart   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + centsPart;
  }

  var formatMatch = formatString.match(placeholderRegex);
  if (!formatMatch) return formatWithDelimiters(cents, 2);

  switch(formatMatch[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
if (!customElements.get('custom-product-bundle')) {
    customElements.define (
        'custom-product-bundle',
        class CustomProductBundle extends HTMLElement {
            constructor() {
                super();

                this.selectProductsID = [];
                this.charmsProductID = [];
                this.mainImageGroup = this.querySelector('.js-main-product-image');
                this.mainImageCharms = this.querySelectorAll('.js-main-img-charm');
                this.charmsImageGroup = this.querySelector('.js-charms-product-image');
                this.zoomStage = this.querySelector('.product-image-main-group');
                this.zoomScale = 1;
                this.zoomMin = 1;
                this.zoomMax = 2.2;
                this.zoomClickScale = 1.6;
                this.zoomPanX = 0;
                this.zoomPanY = 0;
                this.zoomDragThreshold = 6;
                this.zoomPointerDrag = null;
                this.zoomTouchDrag = null;
                this.zoomSuppressClick = false;
                this.zoomPinchDistance = null;
                this.zoomPinchStartScale = 1;
                this.zoomPinchStartMidpoint = null;
                this.zoomPinchStartPan = null;
                this.zoomListeners = null;

                this.mobBaseTabs = this.querySelectorAll('.js-mob-base-tab');
                this.mobBaseContainers = this.querySelectorAll('.js-mob-tab-container');

                // Use one source of truth at every breakpoint. The old mobile-only
                // controls duplicated state and broke after rotation or resize.
                this.flipFlopSize = this.querySelector('.js-flip-slop-size');
                this.sizeButtons = this.querySelectorAll('.js-size-button');
                this.soleColors = this.querySelectorAll('.js-flip-flop-sole-color');
                this.activeSole = this.querySelector('.js-flip-flop-sole-color.active-color');
                this.soleColorName = this.querySelector('.js-sole-color-name');

                this.strapColors = this.querySelectorAll('.js-flip-flop-strap-color');
                this.activeStrap = this.querySelector('.js-flip-flop-strap-color.active-color');
                this.strapColorName = this.querySelector('.js-strap-color-name');

                this.currentStep = 0;
                this.stepTabs = this.querySelectorAll('.js-tabs-content');
                this.stepPanels = this.querySelectorAll('.js-tabs-inner');
                this.stepBackButton = this.querySelector('.js-step-back');
                this.stepNextButton = this.querySelector('.js-step-next');
                this.stepMessage = this.querySelector('.js-configurator-message');
                this.stepHint = this.querySelector('.js-step-hint');
                this.menuButton = this.querySelector('.js-configurator-menu');
                this.undoButtons = this.querySelectorAll('.js-bundle-undo-btn');
                this.undoButton = this.undoButtons[0] || null;
                this.undoHistory = [];
                this.historyLimit = 30;
                this.isRestoringHistory = false;
                this._historyMutationDepth = 0;
                this._lastCommittedState = null;

                this.bundleWrapper = this.querySelector('.js-bundle-wrapper');
                this.warningWrapper = this.querySelector('.js-warning-wrapper');

                this.footButtons = this.querySelectorAll('.js-foot-selector');
                this.leftFootImage = this.querySelector('.js-charms-left-foot');
                this.rightFootImage = this.querySelector('.js-charms-right-foot');
                this.filters = this.querySelectorAll('.charms-tabs .js-filter');
                
                this.ribbonHardwareFilterBtn = this.querySelector('.js-ribbon-hardware-filter-btn');
                this.ribbonHardwareFilter = this.querySelector('.js-ribbon-hardware-filter');
                this.ribbonSelectedFiltersWrapper = this.querySelector('.js-ribbon-selected-filters');
                this.ribbonFilters = this.querySelectorAll('.ribbons-tabs .js-ribbon-filter');
                
                this.insertPopup = this.querySelector('.js-charms-insert-pop-up');
                this.insertCharm = this.insertPopup.querySelector('.js-charm-insert-btn');
                this.removeCharm = this.insertPopup.querySelector('.js-charm-remove-btn');
                this.rotateCharm = this.insertPopup.querySelector('.js-charm-rotation-btn');

                this.activeCharmPosition = null;
                this.charms = this.querySelectorAll('.js-prod-charms');
                this.charmPositions = this.querySelectorAll('.js-charm-positions');

                this.querySelectorAll('.js-bundle-reset-btn').forEach((button) => {
                    button.addEventListener('click', this.resetBundleWarning.bind(this));
                });
                this.undoButtons.forEach((button) => {
                    button.addEventListener('click', () => this.undoLastChange());
                });

                if (this.menuButton) {
                    this.menuButton.addEventListener('click', () => {
                        const drawer = document.querySelector('#Details-menu-drawer-container');
                        const summary = drawer?.querySelector('summary');
                        if (!drawer || !summary) return;

                        document.body.classList.add('configurator-menu-open');
                        if (!drawer.open) summary.click();
                    });

                    const drawer = document.querySelector('#Details-menu-drawer-container');
                    drawer?.addEventListener('toggle', () => {
                        if (!drawer.open) document.body.classList.remove('configurator-menu-open');
                    });
                }

                let bundleAddCartBtn = this.querySelector('.js-bundle-add-to-cart');
                if(bundleAddCartBtn) {
                    bundleAddCartBtn.addEventListener('click', this.handleBundleAddToCart.bind(this))
                }
                
                this.activeCharm = null;
                if(this.charmPositions.length > 0) {
                    this.charmPositions.forEach((position) => {
                        position.addEventListener('click', () => {
                            if (position.classList.contains('js-is-not-empty')) {
                                this.handleCharms(position);
                                return;
                            }

                            if (!this.activeCharm || !this.checkSpaceBetweenCharms(position, this.activeCharm)) {
                                return;
                            }

                            // Placement previews are transient. Rebuild the clicked
                            // slot from actual occupancy before opening its controls.
                            this.placeCharms(this.activeCharm, { silent: true });
                            this.handleCharms(position);
                            let spaceRequired = position.getAttribute('data-space-required');
                            if(spaceRequired) {
                                this.rotateCharm.classList.toggle('hidden', spaceRequired === "4");
                            }
                        });
                        position.addEventListener('mouseenter', () => this.setCharmGroupEmphasis(position, true));
                        position.addEventListener('mouseleave', () => this.setCharmGroupEmphasis(position, false));
                        position.addEventListener('focus', () => this.setCharmGroupEmphasis(position, true));
                        position.addEventListener('blur', () => this.setCharmGroupEmphasis(position, false));
                    })
                }
            }
            
            connectedCallback() {
                this.initializeSoleSlider('js-sole-slider', 1);
                this.initializeSoleSlider('js-strap-slider', 2);
                this.handleTabs();
                this.handleStepActions();
                this.selectBase();
                this.setFilters();
                this.selectRibbons();
                this.setRibbonFilters();
                this.initializeBasePlaceholder();
                this.initializeDefaultBaseSelections();
                this.handleWarning();
                this.selectFootImage();
                this.applyShoeCameraMode(this.currentStep);
                this.initializeShoeZoom();

                if (this.insertCharm) {
                    this.insertCharm.addEventListener('click', () => {
                    if (this.activeCharmPosition) this.insertSelectedCharm(this.activeCharmPosition);
                    });
                }

                if (this.removeCharm) {
                    this.removeCharm.addEventListener('click', () => {
                    if (this.activeCharmPosition) this.removeSelectedCharm(this.activeCharmPosition);
                    });
                }

                if (this.rotateCharm) {
                    this.rotateCharm.addEventListener('click', () => {
                    if (this.activeCharmPosition) this.rotateSelectedCharm(this.activeCharmPosition);
                    });
                }

                this.addEventListener('keydown', (event) => {
                    if (event.key !== 'Escape') return;
                    const openModal = this.querySelector('.sec-pop-up:not(.hidden)');
                    if (openModal) this.closeModal(openModal);
                });

                this.updateStepNavigation();
                this.initializeHistory();
                this.ensureCharmsCatalog();
                this.ensureRibbonsCatalog();
            }

            disconnectedCallback() {
                this.destroyShoeZoom();
            }

            clampZoomScale(scale) {
                const numericScale = Number(scale);
                if (!Number.isFinite(numericScale)) return this.zoomMin ?? 1;
                return Math.min(this.zoomMax ?? 2.2, Math.max(this.zoomMin ?? 1, numericScale));
            }

            getTouchDistance(touches) {
                if (!touches || touches.length < 2) return 0;
                return Math.hypot(
                    touches[1].clientX - touches[0].clientX,
                    touches[1].clientY - touches[0].clientY
                );
            }

            getTouchMidpoint(touches) {
                if (!touches || touches.length < 2) return null;
                return {
                    x: (touches[0].clientX + touches[1].clientX) / 2,
                    y: (touches[0].clientY + touches[1].clientY) / 2,
                };
            }

            hasExceededZoomDragThreshold(deltaX, deltaY) {
                return Math.hypot(deltaX, deltaY) >= (this.zoomDragThreshold ?? 6);
            }

            getActiveZoomSurface() {
                const mainSurface = this.mainImageGroup;
                if (mainSurface && !mainSurface.classList?.contains('hidden')) return mainSurface;
                return this.querySelector?.('.js-charm-image:not(.hidden)') || null;
            }

            getShoePanBounds(surface = this.getActiveZoomSurface(), scale = this.zoomScale) {
                const stageBounds = this.zoomStage?.getBoundingClientRect?.();
                const surfaceBounds = surface?.getBoundingClientRect?.();
                if (!stageBounds || !surfaceBounds) {
                    return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
                }
                const safeEdge = 24;
                const numericScale = this.clampZoomScale(scale);
                const baseWidth = surface.offsetWidth || surfaceBounds.width / (this.zoomScale || 1);
                const baseHeight = surface.offsetHeight || surfaceBounds.height / (this.zoomScale || 1);
                const centerX = surfaceBounds.left + surfaceBounds.width / 2 - this.zoomPanX;
                const centerY = surfaceBounds.top + surfaceBounds.height / 2 - this.zoomPanY;
                const scaledWidth = baseWidth * numericScale;
                const scaledHeight = baseHeight * numericScale;
                const axisBounds = (stageStart, stageEnd, center, scaledSize) => {
                    if (scaledSize <= stageEnd - stageStart - safeEdge * 2) return [0, 0];
                    return [
                        stageEnd - safeEdge - (center + scaledSize / 2),
                        stageStart + safeEdge - (center - scaledSize / 2),
                    ];
                };
                const [minX, maxX] = axisBounds(stageBounds.left, stageBounds.right, centerX, scaledWidth);
                const [minY, maxY] = axisBounds(stageBounds.top, stageBounds.bottom, centerY, scaledHeight);
                return { minX, maxX, minY, maxY };
            }

            setShoePan(x, y, surface = this.getActiveZoomSurface()) {
                if (this.zoomScale <= this.zoomMin + 0.001) {
                    this.zoomPanX = 0;
                    this.zoomPanY = 0;
                } else {
                    const bounds = this.getShoePanBounds(surface, this.zoomScale);
                    this.zoomPanX = Math.min(bounds.maxX, Math.max(bounds.minX, Number(x) || 0));
                    this.zoomPanY = Math.min(bounds.maxY, Math.max(bounds.minY, Number(y) || 0));
                }
                this.zoomStage?.style.setProperty('--shoe-pan-x', `${this.zoomPanX}px`);
                this.zoomStage?.style.setProperty('--shoe-pan-y', `${this.zoomPanY}px`);
                return { x: this.zoomPanX, y: this.zoomPanY };
            }

            setShoeZoom(scale, { immediate = false } = {}) {
                this.zoomScale = this.clampZoomScale(scale);
                if (!this.zoomStage) return this.zoomScale;
                this.zoomStage.style.setProperty('--shoe-zoom', String(this.zoomScale));
                this.zoomStage.classList.toggle('is-shoe-zoomed', this.zoomScale > this.zoomMin + 0.001);
                this.zoomStage.classList.toggle('is-shoe-zoom-immediate', immediate);
                this.setShoePan(this.zoomPanX, this.zoomPanY);
                return this.zoomScale;
            }

            resetShoeZoom({ immediate = false } = {}) {
                this.zoomPinchDistance = null;
                this.zoomPointerDrag = null;
                this.zoomTouchDrag = null;
                this.zoomStage?.classList.remove('is-shoe-pinching', 'is-shoe-panning');
                const scale = this.setShoeZoom(this.zoomMin, { immediate });
                this.setShoePan(0, 0);
                return scale;
            }

            getShoeCameraMode(stepIndex = this.currentStep) {
                return Number(stepIndex) === 1 ? 'charm-detail-crop' : 'pair-fit';
            }

            applyShoeCameraMode(stepIndex = this.currentStep) {
                const mode = this.getShoeCameraMode(stepIndex);
                if (this.zoomStage) this.zoomStage.dataset.shoeCamera = mode;
                return mode;
            }

            getZoomSurfaceFromTarget(target) {
                const surface = target?.closest?.('.js-main-product-image, .js-charm-image');
                return surface && this.zoomStage?.contains(surface) ? surface : null;
            }

            isShoeClickZoomTarget(target) {
                if (!this.getZoomSurfaceFromTarget(target)) return false;
                return !target?.closest?.(
                    'button, a, input, select, textarea, [role="button"], '
                    + '.js-charm-positions, .js-prod-charms, .js-main-img-charm, .js-sole-ribbon'
                );
            }

            zoomShoeAtPoint(scale, clientX, clientY, surface) {
                const bounds = surface?.getBoundingClientRect?.();
                if (!bounds?.width || !bounds?.height || !this.zoomStage) return false;
                const nextScale = this.clampZoomScale(scale);
                const scaleDelta = nextScale / (this.zoomScale || 1) - 1;
                const centerX = bounds.left + bounds.width / 2;
                const centerY = bounds.top + bounds.height / 2;
                const nextX = this.zoomPanX + (centerX - clientX) * scaleDelta;
                const nextY = this.zoomPanY + (centerY - clientY) * scaleDelta;
                this.setShoeZoom(nextScale);
                this.setShoePan(nextX, nextY, surface);
                return true;
            }

            initializeShoeZoom() {
                if (!this.zoomStage || this.zoomListeners) return;

                const touchStart = (event) => {
                    if (event.touches.length === 2) {
                        const surfaces = Array.from(event.touches, touch => this.getZoomSurfaceFromTarget(touch.target));
                        if (!surfaces[0] || surfaces.some(surface => surface !== surfaces[0])) return;
                        const distance = this.getTouchDistance(event.touches);
                        if (!distance) return;
                        this.zoomPinchDistance = distance;
                        this.zoomPinchStartScale = this.zoomScale;
                        this.zoomPinchStartMidpoint = this.getTouchMidpoint(event.touches);
                        this.zoomPinchStartPan = { x: this.zoomPanX, y: this.zoomPanY };
                        this.zoomTouchDrag = null;
                        this.zoomStage.classList.add('is-shoe-pinching');
                        return;
                    }
                    if (
                        event.touches.length === 1
                        && this.zoomScale > this.zoomMin + 0.001
                        && this.isShoeClickZoomTarget(event.touches[0].target)
                    ) {
                        const touch = event.touches[0];
                        this.zoomTouchDrag = {
                            surface: this.getZoomSurfaceFromTarget(touch.target),
                            startX: touch.clientX,
                            startY: touch.clientY,
                            panX: this.zoomPanX,
                            panY: this.zoomPanY,
                            moved: false,
                        };
                    }
                };
                const touchMove = (event) => {
                    if (this.zoomPinchDistance !== null && event.touches.length >= 2) {
                        event.preventDefault();
                        const distance = this.getTouchDistance(event.touches);
                        const midpoint = this.getTouchMidpoint(event.touches);
                        this.setShoeZoom(
                            this.zoomPinchStartScale * (distance / this.zoomPinchDistance),
                            { immediate: true }
                        );
                        this.setShoePan(
                            this.zoomPinchStartPan.x + midpoint.x - this.zoomPinchStartMidpoint.x,
                            this.zoomPinchStartPan.y + midpoint.y - this.zoomPinchStartMidpoint.y,
                            this.getZoomSurfaceFromTarget(event.touches[0].target)
                        );
                        return;
                    }
                    if (!this.zoomTouchDrag || event.touches.length !== 1) return;
                    const touch = event.touches[0];
                    const dx = touch.clientX - this.zoomTouchDrag.startX;
                    const dy = touch.clientY - this.zoomTouchDrag.startY;
                    if (!this.zoomTouchDrag.moved && !this.hasExceededZoomDragThreshold(dx, dy)) return;
                    this.zoomTouchDrag.moved = true;
                    event.preventDefault();
                    this.setShoePan(
                        this.zoomTouchDrag.panX + dx,
                        this.zoomTouchDrag.panY + dy,
                        this.zoomTouchDrag.surface
                    );
                };
                const touchEnd = (event) => {
                    if (event.touches.length >= 2) return;
                    this.zoomPinchDistance = null;
                    this.zoomPinchStartMidpoint = null;
                    this.zoomPinchStartPan = null;
                    if (!event.touches.length) this.zoomTouchDrag = null;
                    this.zoomStage.classList.remove('is-shoe-pinching', 'is-shoe-zoom-immediate');
                };
                const wheel = (event) => {
                    if (!event.ctrlKey || !this.getZoomSurfaceFromTarget(event.target)) return;
                    event.preventDefault();
                    const exponent = Math.max(-0.12, Math.min(0.12, -event.deltaY * 0.01));
                    this.zoomShoeAtPoint(
                        this.zoomScale * Math.exp(exponent),
                        event.clientX,
                        event.clientY,
                        this.getZoomSurfaceFromTarget(event.target)
                    );
                    this.zoomStage.classList.add('is-shoe-zoom-immediate');
                };
                const pointerDown = (event) => {
                    if (event.pointerType === 'touch' || event.button !== 0) return;
                    if (this.zoomScale <= this.zoomMin + 0.001 || !this.isShoeClickZoomTarget(event.target)) return;
                    this.zoomPointerDrag = {
                        pointerId: event.pointerId,
                        surface: this.getZoomSurfaceFromTarget(event.target),
                        startX: event.clientX,
                        startY: event.clientY,
                        panX: this.zoomPanX,
                        panY: this.zoomPanY,
                        moved: false,
                    };
                    event.target.setPointerCapture?.(event.pointerId);
                };
                const pointerMove = (event) => {
                    const drag = this.zoomPointerDrag;
                    if (!drag || drag.pointerId !== event.pointerId) return;
                    const dx = event.clientX - drag.startX;
                    const dy = event.clientY - drag.startY;
                    if (!drag.moved && !this.hasExceededZoomDragThreshold(dx, dy)) return;
                    drag.moved = true;
                    event.preventDefault();
                    this.zoomStage.classList.add('is-shoe-panning');
                    this.setShoePan(drag.panX + dx, drag.panY + dy, drag.surface);
                };
                const pointerUp = (event) => {
                    const drag = this.zoomPointerDrag;
                    if (!drag || drag.pointerId !== event.pointerId) return;
                    if (drag.moved) this.zoomSuppressClick = true;
                    event.target.releasePointerCapture?.(event.pointerId);
                    this.zoomPointerDrag = null;
                    this.zoomStage.classList.remove('is-shoe-panning');
                };
                const click = (event) => {
                    if (!window.matchMedia?.('(min-width: 1024px)').matches) return;
                    if (this.zoomSuppressClick) {
                        this.zoomSuppressClick = false;
                        return;
                    }
                    if (event.detail > 1 || !this.isShoeClickZoomTarget(event.target)) return;
                    const surface = this.getZoomSurfaceFromTarget(event.target);
                    event.preventDefault();
                    if (this.zoomScale > this.zoomMin + 0.001) {
                        this.resetShoeZoom();
                        return;
                    }
                    this.zoomShoeAtPoint(this.zoomClickScale, event.clientX, event.clientY, surface);
                };
                const doubleClick = (event) => {
                    if (!this.isShoeClickZoomTarget(event.target)) return;
                    event.preventDefault();
                    this.resetShoeZoom();
                };

                this.zoomListeners = {
                    touchStart, touchMove, touchEnd, wheel,
                    pointerDown, pointerMove, pointerUp, click, doubleClick
                };
                this.zoomStage.addEventListener('touchstart', touchStart, { passive: true });
                this.zoomStage.addEventListener('touchmove', touchMove, { passive: false });
                this.zoomStage.addEventListener('touchend', touchEnd);
                this.zoomStage.addEventListener('touchcancel', touchEnd);
                this.zoomStage.addEventListener('wheel', wheel, { passive: false });
                this.zoomStage.addEventListener('pointerdown', pointerDown);
                this.zoomStage.addEventListener('pointermove', pointerMove);
                this.zoomStage.addEventListener('pointerup', pointerUp);
                this.zoomStage.addEventListener('pointercancel', pointerUp);
                this.zoomStage.addEventListener('click', click);
                this.zoomStage.addEventListener('dblclick', doubleClick);
                this.setShoeZoom(this.zoomScale, { immediate: true });
                requestAnimationFrame(() => this.zoomStage?.classList.remove('is-shoe-zoom-immediate'));
            }

            destroyShoeZoom() {
                if (!this.zoomStage || !this.zoomListeners) return;
                const {
                    touchStart, touchMove, touchEnd, wheel,
                    pointerDown, pointerMove, pointerUp, click, doubleClick
                } = this.zoomListeners;
                this.zoomStage.removeEventListener('touchstart', touchStart);
                this.zoomStage.removeEventListener('touchmove', touchMove);
                this.zoomStage.removeEventListener('touchend', touchEnd);
                this.zoomStage.removeEventListener('touchcancel', touchEnd);
                this.zoomStage.removeEventListener('wheel', wheel);
                this.zoomStage.removeEventListener('pointerdown', pointerDown);
                this.zoomStage.removeEventListener('pointermove', pointerMove);
                this.zoomStage.removeEventListener('pointerup', pointerUp);
                this.zoomStage.removeEventListener('pointercancel', pointerUp);
                this.zoomStage.removeEventListener('click', click);
                this.zoomStage.removeEventListener('dblclick', doubleClick);
                this.zoomListeners = null;
                this.zoomPinchDistance = null;
            }

            initializeHistory() {
                this.undoHistory = [];
                this._lastCommittedState = this.captureConfiguratorState();
                this.updateUndoControl();
            }

            cloneHistoryState(state) {
                return state ? JSON.parse(JSON.stringify(state)) : state;
            }

            snapshotElements(elements) {
                const attributes = [
                    'src', 'aria-pressed', 'data-space-required', 'data-charm-name',
                    'data-charm-id', 'data-charm-price', 'data-rotation'
                ];
                return Array.from(elements || []).map(element => ({
                    classes: Array.from(element.classList || []),
                    attributes: attributes.reduce((result, name) => {
                        const value = element.getAttribute?.(name);
                        if (value !== null && value !== undefined) result[name] = value;
                        return result;
                    }, {}),
                    style: {
                        opacity: element.style?.opacity || '',
                        cursor: element.style?.cursor || '',
                        transform: element.style?.transform || '',
                        transition: element.style?.transition || ''
                    }
                }));
            }

            restoreElements(elements, snapshots) {
                Array.from(elements || []).forEach((element, index) => {
                    const snapshot = snapshots?.[index];
                    if (!snapshot) return;
                    Array.from(element.classList || []).forEach(className => element.classList.remove(className));
                    snapshot.classes.forEach(className => element.classList.add(className));
                    [
                        'src', 'aria-pressed', 'data-space-required', 'data-charm-name',
                        'data-charm-id', 'data-charm-price', 'data-rotation'
                    ].forEach(name => {
                        if (Object.prototype.hasOwnProperty.call(snapshot.attributes, name)) {
                            element.setAttribute(name, snapshot.attributes[name]);
                        } else {
                            element.removeAttribute(name);
                        }
                    });
                    Object.assign(element.style || {}, snapshot.style);
                });
            }

            captureConfiguratorState() {
                const activeRibbon = this.querySelector?.('.js-flip-flop-ribbon.active');
                const selectedFoot = Array.from(this.footButtons || []).findIndex(
                    button => button.getAttribute('aria-pressed') === 'true'
                );
                const layerSelectors = [
                    '.js-left-sole', '.js-right-sole', '.js-charms-left-foot-sole',
                    '.js-charms-right-foot-sole', '.js-left-strap', '.js-right-strap',
                    '.js-charms-left-foot-strap', '.js-charms-right-foot-strap'
                ];
                return {
                    size: this.flipFlopSize?.value || '',
                    soleHandle: this.activeSole?.getAttribute('data-sole-color-name') || '',
                    strapHandle: this.activeStrap?.getAttribute('data-strap-color-name') || '',
                    soleLabel: this.soleColorName?.textContent || '',
                    strapLabel: this.strapColorName?.textContent || '',
                    selectedProducts: this.cloneHistoryState(this.selectProductsID || []),
                    charmProducts: Array.from(this.charmsProductID || []),
                    charmElements: this.snapshotElements(this.charms),
                    charmPositions: this.snapshotElements(this.charmPositions),
                    mainCharmElements: this.snapshotElements(this.mainImageCharms),
                    ribbonTitle: activeRibbon?.getAttribute('data-ribbon-variant-title') || '',
                    ribbonId: activeRibbon?.getAttribute('data-ribbon-variant-id') || '',
                    ribbonElements: this.snapshotElements(this.querySelectorAll?.('.js-flip-flop-ribbon') || []),
                    ribbonImages: this.snapshotElements(this.querySelectorAll?.('.js-sole-ribbon') || []),
                    layerImages: layerSelectors.map(selector => this.querySelector?.(selector)?.getAttribute('src') || ''),
                    charmName: this.querySelector?.('.js-charm-name')?.textContent || 'None',
                    activeCharmId: this.activeCharm?.getAttribute('data-charm-variant-id') || '',
                    selectedFoot
                };
            }

            mutateWithHistory(callback) {
                if (!Number.isFinite(this._historyMutationDepth)) this._historyMutationDepth = 0;
                if (!Array.isArray(this.undoHistory)) this.undoHistory = [];
                if (!Number.isFinite(this.historyLimit)) this.historyLimit = 30;
                if (this.isRestoringHistory || this._historyMutationDepth > 0) return callback();
                const before = this.cloneHistoryState(this._lastCommittedState || this.captureConfiguratorState());
                this._historyMutationDepth += 1;
                let result;
                try {
                    result = callback();
                } finally {
                    this._historyMutationDepth -= 1;
                    const after = this.captureConfiguratorState();
                    if (JSON.stringify(before) !== JSON.stringify(after)) {
                        this.undoHistory.push(before);
                        if (this.undoHistory.length > this.historyLimit) this.undoHistory.shift();
                    }
                    this._lastCommittedState = after;
                    this.updateUndoControl();
                }
                return result;
            }

            updateUndoControl() {
                const disabled = !this.undoHistory?.length || this.isRestoringHistory;
                const buttons = this.undoButtons?.length
                    ? this.undoButtons
                    : this.undoButton
                        ? [this.undoButton]
                        : [];
                buttons.forEach((button) => {
                    button.disabled = disabled;
                    button.setAttribute('aria-disabled', String(disabled));
                });
            }

            undoLastChange() {
                if (!this.undoHistory?.length || this.isRestoringHistory) return false;
                const state = this.undoHistory.pop();
                this.restoreConfiguratorState(state);
                return true;
            }

            restoreConfiguratorState(state) {
                if (!state) return;
                this.isRestoringHistory = true;
                try {
                    if (this.flipFlopSize) this.flipFlopSize.value = state.size;
                    this.sizeButtons?.forEach(button => {
                        const selected = button.dataset.size === state.size;
                        button.classList.toggle('active', selected);
                        button.setAttribute('aria-pressed', String(selected));
                    });

                    this.soleColors?.forEach(option => {
                        option.classList.remove('active-color');
                        option.setAttribute('aria-pressed', 'false');
                    });
                    this.strapColors?.forEach(option => {
                        option.classList.remove('active-color');
                        option.setAttribute('aria-pressed', 'false');
                    });
                    this.activeSole = Array.from(this.soleColors || []).find(
                        option => option.getAttribute('data-sole-color-name') === state.soleHandle
                    ) || null;
                    this.activeStrap = Array.from(this.strapColors || []).find(
                        option => option.getAttribute('data-strap-color-name') === state.strapHandle
                    ) || null;
                    if (this.activeSole) this.handleSoleColors(this.activeSole);
                    if (this.activeStrap) this.handleStrapColors(this.activeStrap);
                    this.classList.toggle('is-awaiting-sole', !this.activeSole);
                    this.classList.toggle('is-awaiting-strap', !this.activeStrap);
                    if (this.soleColorName) this.soleColorName.textContent = state.soleLabel;
                    if (this.strapColorName) this.strapColorName.textContent = state.strapLabel;

                    this.selectProductsID = this.cloneHistoryState(state.selectedProducts);
                    this.charmsProductID = Array.from(state.charmProducts || []);
                    this.restoreElements(this.charms, state.charmElements);
                    this.restoreElements(this.charmPositions, state.charmPositions);
                    this.restoreElements(this.mainImageCharms, state.mainCharmElements);

                    const ribbons = this.querySelectorAll?.('.js-flip-flop-ribbon') || [];
                    this.restoreElements(ribbons, state.ribbonElements);
                    this.restoreElements(this.querySelectorAll?.('.js-sole-ribbon') || [], state.ribbonImages);
                    const layerSelectors = [
                        '.js-left-sole', '.js-right-sole', '.js-charms-left-foot-sole',
                        '.js-charms-right-foot-sole', '.js-left-strap', '.js-right-strap',
                        '.js-charms-left-foot-strap', '.js-charms-right-foot-strap'
                    ];
                    layerSelectors.forEach((selector, index) => {
                        const layer = this.querySelector?.(selector);
                        if (layer) layer.src = state.layerImages?.[index] || '';
                    });
                    const ribbonName = this.querySelector?.('.js-ribbon-head');
                    if (ribbonName) ribbonName.textContent = state.ribbonTitle || 'No ribbon';
                    const charmName = this.querySelector?.('.js-charm-name');
                    if (charmName) charmName.textContent = state.charmName || 'None';

                    this.activeCharm = state.activeCharmId
                        ? this.querySelector?.(`.js-flip-flop-charm[data-charm-variant-id="${state.activeCharmId}"]`) || null
                        : null;
                    const charmOptions = this.querySelectorAll?.('.js-flip-flop-charm') || [];
                    charmOptions.forEach(option => {
                        const selected = Boolean(
                            state.activeCharmId
                            && option.getAttribute('data-charm-variant-id') === state.activeCharmId
                        );
                        option.classList.toggle('active', selected);
                        option.setAttribute('aria-pressed', String(selected));
                    });
                    if (this.clearCharmsBtn) {
                        const selected = !state.activeCharmId;
                        this.clearCharmsBtn.classList.toggle('active', selected);
                        this.clearCharmsBtn.setAttribute('aria-pressed', String(selected));
                    }
                    this.activeCharmPosition = null;
                    this.insertPopup?.classList.add('hidden');
                    this.footButtons?.forEach((button, index) => {
                        const selected = index === state.selectedFoot;
                        button.classList.toggle('active', selected);
                        button.setAttribute('aria-pressed', String(selected));
                    });
                    if (state.selectedFoot >= 0) {
                        this.leftFootImage?.classList.toggle('hidden', state.selectedFoot !== 0);
                        this.rightFootImage?.classList.toggle('hidden', state.selectedFoot === 0);
                    }
                    this.refreshCharmPlacementPreviews();

                    this.clearStepMessage();
                    if (this.currentStep > 0 && this.getMissingBaseRequirement()) {
                        this.activateStep(0);
                    } else {
                        this.updateStepNavigation();
                        if (this.stepTabs?.[this.currentStep]?.classList.contains('js-add-to-cart-tab')) {
                            this.handleAddToCartTab();
                        }
                    }
                    this.handleTotalPrice();
                } finally {
                    this.isRestoringHistory = false;
                    this._lastCommittedState = this.captureConfiguratorState();
                    this.updateUndoControl();
                }
            }

            getStrapSizeMapping() {
                return {
                    "32": "2-3",
                    "33": "2-3",
                    "34": "4-5",
                    "35": "4-5",
                    "36": "6-7",
                    "37": "6-7",
                    "38": "8-9",
                    "39": "8-9",
                    "40": "10-11",
                    "41": "10-11",
                    "42": "12-13"
                };
            }

            parseCharmEntry(entry) {
                const parts = String(entry || '').split(':');
                const position = parts.shift() || '';
                const rotation = parts.pop() || '0';
                const price = parts.pop() || '0';
                const id = parts.pop() || '';
                const name = parts.join(':');
                return { position, name, id, price, rotation };
            }

            serializeCharmEntry({ position, name, id, price, rotation = 0 }) {
                return `${position}:${name}:${id}:${price}:${rotation}`;
            }

            isElementOutOfStock(el) {
                if (!el) return false;
                if (el.classList.contains('js-clear-charms') || el.classList.contains('js-remove-ribbon')) return false;
                if (el.dataset.outOfStock === 'true' || el.classList.contains('is-out-of-stock')) return true;
                if (el.classList.contains('js-flip-flop-ribbon') && el.dataset.inventoryPolicy !== 'continue') {
                    const qty = parseInt(el.getAttribute('data-inventory-quantity'), 10);
                    if (!isNaN(qty)) return qty <= 1;
                }
                return false;
            }

            getBaseColorVariant(type, colorName, selectedSize = '') {
                const isStrap = type === 'strap';
                const script = this.querySelector(
                    isStrap ? '.js-strap-color-product' : '.js-sole-color-product'
                );
                if (!script || !colorName) return null;

                let data;
                try {
                    data = JSON.parse(script.textContent);
                } catch (error) {
                    console.warn(`Unable to read ${type} color inventory`, error);
                    return null;
                }

                if (selectedSize) {
                    const variantSize = isStrap
                        ? this.getStrapSizeMapping()[selectedSize]
                        : selectedSize;
                    return data[`${variantSize}-${colorName}`] || null;
                }

                return Object.entries(data).find(([key, variant]) => (
                    key.endsWith(`-${colorName}`) && variant?.available !== false
                ))?.[1] || null;
            }

            isValidDefaultBaseOption(option, type) {
                if (!option || option.classList.contains('hidden')) return false;
                if (option.disabled || option.hasAttribute?.('disabled')) return false;
                if (option.getAttribute('aria-disabled') === 'true' || this.isElementOutOfStock(option)) {
                    return false;
                }
                const colorName = option.getAttribute(
                    type === 'strap' ? 'data-strap-color-name' : 'data-sole-color-name'
                );
                return !!this.getBaseColorVariant(type, colorName);
            }

            initializeDefaultBaseSelections() {
                const firstSole = Array.from(this.soleColors || []).find(
                    option => this.isValidDefaultBaseOption(option, 'sole')
                );
                const firstStrap = Array.from(this.strapColors || []).find(
                    option => this.isValidDefaultBaseOption(option, 'strap')
                );

                const wasRestoringHistory = this.isRestoringHistory;
                this.isRestoringHistory = true;
                try {
                    if (firstSole) this.handleSoleColors(firstSole);
                    if (firstStrap) this.handleStrapColors(firstStrap);
                } finally {
                    this.isRestoringHistory = wasRestoringHistory;
                }
            }

            updateBaseColorStockStates(type = 'sole') {
                const selectedSize = this.flipFlopSize?.value;
                if (!selectedSize) return;

                const isStrap = type === 'strap';
                const script = this.querySelector(isStrap ? '.js-strap-color-product' : '.js-sole-color-product');
                if (!script) return;

                const data = JSON.parse(script.textContent);
                const swatches = isStrap ? this.strapColors : this.soleColors;
                const sizeMapping = this.getStrapSizeMapping();

                swatches.forEach(swatch => {
                    const colorName = swatch.getAttribute(isStrap ? 'data-strap-color-name' : 'data-sole-color-name');
                    if (!colorName) return;

                    const key = isStrap
                        ? `${sizeMapping[selectedSize]}-${colorName}`
                        : `${selectedSize}-${colorName}`;

                    const variantData = data[key];
                    const inStock = !!(variantData && variantData.available !== false);

                    swatch.classList.toggle('is-out-of-stock', !inStock);
                    swatch.setAttribute('data-out-of-stock', inStock ? 'false' : 'true');
                    swatch.setAttribute('aria-disabled', inStock ? 'false' : 'true');
                    swatch.querySelector('.bundle-stock-label')?.remove();
                });

                const activeSwatch = isStrap ? this.activeStrap : this.activeSole;
                if (activeSwatch?.classList.contains('is-out-of-stock')) {
                    const firstAvailable = Array.from(swatches).find(
                        s => !s.classList.contains('hidden') && !s.classList.contains('is-out-of-stock')
                    );
                    if (firstAvailable) {
                        if (isStrap) this.handleStrapColors(firstAvailable);
                        else this.handleSoleColors(firstAvailable);
                    }
                }
            }

            handleMobBaseTabs() {
                this.mobBaseTabs.forEach((tab) => {
                    tab.addEventListener('click', () => {
                        this.mobBaseTabs.forEach(t => t.classList.remove('active-tab'));
                        tab.classList.add('active-tab');

                        let tabName = tab.getAttribute('data-mob-base-tab');
                        let container = this.querySelector(`.js-mob-tab-container[data-mob-base-container="${tabName}"]`);

                        this.mobBaseContainers.forEach(c => c.classList.add('hidden'));
                        container.classList.remove('hidden');
                    });
                });
            }

            handleTabs() {
                let tabIcons = this.stepTabs;
                let tabContents = this.stepPanels;

                if(tabIcons.length > 0 && tabContents.length > 0) {
                    tabIcons.forEach((icon, index) => {
                        icon.addEventListener('click', () => {
                            this.activateStep(index);
                        });
                        icon.addEventListener('keydown', (event) => {
                            let targetIndex = index;
                            if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabIcons.length;
                            else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabIcons.length) % tabIcons.length;
                            else if (event.key === 'Home') targetIndex = 0;
                            else if (event.key === 'End') targetIndex = tabIcons.length - 1;
                            else return;

                            event.preventDefault();
                            if (this.activateStep(targetIndex)) {
                                tabIcons[targetIndex].focus();
                            }
                        });
                    });
                }
            }

            handleStepActions() {
                this.stepNextButton?.addEventListener('click', () => {
                    const missingRequirement = this.getMissingBaseRequirement();
                    if (this.currentStep === 0 && missingRequirement) {
                        this.promptForBaseRequirement(missingRequirement);
                        return;
                    }
                    if (this.currentStep === this.stepTabs.length - 1) {
                        this.querySelector('.js-bundle-add-to-cart')?.click();
                        return;
                    }
                    this.activateStep(this.currentStep + 1);
                });
            }

            activateStep(index) {
                if (index < 0 || index >= this.stepTabs.length) return false;

                const missingRequirement = this.getMissingBaseRequirement();
                if (index > 0 && missingRequirement) {
                    this.promptForBaseRequirement(missingRequirement);
                    this.updateStepNavigation();
                    return false;
                }

                this.clearStepMessage();
                this.bundleWrapper?.classList.remove('hidden');
                this.warningWrapper?.classList.add('hidden');

                this.stepTabs.forEach((tab, tabIndex) => {
                    const isActive = tabIndex === index;
                    tab.classList.toggle('active', isActive);
                    tab.classList.toggle('is-complete', tabIndex < index);
                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.setAttribute('tabindex', isActive ? '0' : '-1');
                });

                this.stepPanels.forEach((panel, panelIndex) => {
                    const isActive = panelIndex === index;
                    panel.classList.toggle('active', isActive);
                    panel.hidden = !isActive;
                });

                const activeTab = this.stepTabs[index];
                if(activeTab.classList.contains('js-charms-image')) {
                    this.ensureCharmsCatalog().then(() => {
                        this.arrangeCharms();
                    });
                    this.charmsImageGroup?.classList.remove('hidden');
                    this.mainImageGroup?.classList.add('hidden');
                } else {
                    this.mainImageGroup?.classList.remove('hidden');
                    this.charmsImageGroup?.classList.add('hidden');
                }

                if(activeTab.classList.contains('js-add-to-cart-tab')) {
                    this.handleAddToCartTab();
                }

                this.applyShoeCameraMode(index);
                if (index !== this.currentStep) this.resetShoeZoom({ immediate: true });
                this.currentStep = index;
                this.updateStepNavigation();
                this.stepPanels[index]?.querySelector('.js-step-heading')?.focus({ preventScroll: true });
                this.resetStepScroll();
                return true;
            }

            updateStepNavigation() {
                const lastStep = this.stepTabs.length - 1;
                const missingRequirement = this.currentStep === 0 ? this.getMissingBaseRequirement() : null;

                if (this.stepNextButton) {
                    this.stepNextButton.disabled = false;
                    this.stepNextButton.textContent = missingRequirement
                        ? missingRequirement.label
                        : this.currentStep === lastStep
                        ? 'Add to cart'
                        : 'Continue';
                }
                if (this.stepHint) {
                    this.stepHint.textContent = missingRequirement ? missingRequirement.message : '';
                }
            }

            getMissingBaseRequirement() {
                if (!this.flipFlopSize?.value) {
                    return {
                        label: 'Select a size',
                        message: 'Choose a size to continue.',
                        target: this.querySelector('.size_guide')
                    };
                }
                if (!this.activeSole) {
                    return {
                        label: 'Select a base',
                        message: 'Choose a base color to continue.',
                        target: this.querySelector('.sole-color-group')
                    };
                }
                if (!this.activeStrap) {
                    return {
                        label: 'Select a strap',
                        message: 'Choose a strap color to continue.',
                        target: this.querySelector('.strap-color-group')
                    };
                }
                return null;
            }

            promptForBaseRequirement(requirement) {
                if (!requirement) return;
                this.showStepMessage(requirement.message);
                const target = requirement.target;
                if (!target) return;
                target.classList.remove('is-attention-required');
                requestAnimationFrame(() => {
                    target.classList.add('is-attention-required');
                    if (window.matchMedia?.('(max-width: 1023px)').matches) {
                        const visibleTop = (this.querySelector('.tabs-name-group')?.getBoundingClientRect().bottom || 0) + 12;
                        const delta = target.getBoundingClientRect().top - visibleTop;
                        window.scrollBy({ top: delta, behavior: 'smooth' });
                    } else {
                        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                    const focusTarget = target.querySelector('.js-size-button')
                        || target.querySelector('button:not([disabled]), a, select');
                    focusTarget?.focus({ preventScroll: true });
                    setTimeout(() => target.classList.remove('is-attention-required'), 2400);
                });
            }

            resetStepScroll() {
                const panelScroller = this.querySelector('.js-tab-wrapper');
                if (panelScroller) panelScroller.scrollTop = 0;
                if (window.matchMedia?.('(max-width: 750px)').matches) {
                    const top = this.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ top, behavior: 'auto' });
                }
            }

            showStepMessage(message) {
                if (!this.stepMessage) return;
                this.stepMessage.textContent = message;
                this.stepMessage.classList.remove('hidden');
            }

            clearStepMessage() {
                if (!this.stepMessage) return;
                this.stepMessage.textContent = '';
                this.stepMessage.classList.add('hidden');
            }

            openModal(modal) {
                if (!modal) return;
                this.lastFocusedElement = document.activeElement;
                this.bundleWrapper?.classList.add('hidden');
                modal.classList.remove('hidden');
                requestAnimationFrame(() => modal.querySelector('button, [href], input, select')?.focus());
            }

            closeModal(modal) {
                if (!modal) return;
                modal.classList.add('hidden');
                this.bundleWrapper?.classList.remove('hidden');
                this.lastFocusedElement?.focus?.();
            }

            handleWarning() {
                let handleWarningBtn = this.querySelector('.js-handle-warning');
                if(handleWarningBtn) {
                    handleWarningBtn.addEventListener('click', () => {
                        this.closeModal(this.warningWrapper);
                        if (this.sizeButtons?.[0]) this.sizeButtons[0].focus();
                        else this.flipFlopSize?.focus();
                    })
                }

                let secondStepBtn = this.querySelector('.js-go-second-step-btn');
                if(secondStepBtn) {
                    secondStepBtn.addEventListener('click', () => {
                        this.closeModal(this.querySelector('.js-no-space-popup'));
                    })
                }

                let cartOkBtn = this.querySelector('.js-cart-ok-gtn');
                if(cartOkBtn) {
                    cartOkBtn.addEventListener('click', () => {
                        this.closeModal(this.querySelector('.js-add-to-cart-warning-popup'));
                    })
                }
                
                let cartGoBackBtn = this.querySelector('.js-cart-go-back');
                if(cartGoBackBtn) {
                    cartGoBackBtn.addEventListener('click', () => {
                        let tabIcons = this.querySelectorAll('.js-tabs-content');
                        tabIcons[1].click();

                        this.closeModal(this.querySelector('.js-add-to-cart-warning-popup'));
                    })
                }

                let handleResetBtns = this.querySelectorAll('.js-rest-btn');
                if(handleResetBtns.length > 0) {
                    handleResetBtns.forEach((btn) => {
                        btn.addEventListener('click', () => {
                            this.closeModal(this.querySelector('.js-reset-warning-popup'));
                            if(btn.classList.contains('js-yes-btn')) {
                                this.resetBundle();
                            }
                        })
                    }) 
                }
            }
            
            selectBase() {
                if (this.flipFlopSize) {
                    this.flipFlopSize.addEventListener('change', () => {
                        this.mutateWithHistory(() => {
                            this.sizeButtons.forEach(button => {
                                const selected = button.dataset.size === this.flipFlopSize.value;
                                button.classList.toggle('active', selected);
                                button.setAttribute('aria-pressed', String(selected));
                            });
                            this.handleStrapSize();
                            this.handleSoleSize();
                            this.clearStepMessage();
                            this.updateStepNavigation();
                        });
                    });
                }
                this.sizeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        this.flipFlopSize.value = button.dataset.size;
                        this.flipFlopSize.dispatchEvent(new Event('change', { bubbles: true }));
                    });
                });

                if (this.soleColors.length > 0) {
                    this.soleColors.forEach((sole) => {
                        sole.addEventListener('click', () => {
                            this.handleSoleColors(sole);
                        });
                    });
                }

                if (this.strapColors.length > 0) {
                    this.strapColors.forEach((strap) => {
                        strap.addEventListener('click', () => {
                            this.handleStrapColors(strap);
                        });
                    });
                }
            }

            initializeBasePlaceholder() {
                const getFirstVisual = (selector, requiredKeys) => {
                    const script = this.querySelector(selector);
                    if (!script) return null;
                    try {
                        const values = Object.values(JSON.parse(script.textContent));
                        return values.find(value => requiredKeys.every(key => value?.[key])) || null;
                    } catch (error) {
                        console.warn('Unable to initialize configurator placeholder', error);
                        return null;
                    }
                };

                const sole = getFirstVisual('.js-sole-color-product', ['left_sole_side', 'right_sole_side']);
                const strap = getFirstVisual('.js-strap-color-product', ['left_strap_side', 'right_strap_side']);
                const setSource = (selector, source) => {
                    const image = this.querySelector(selector);
                    if (image && source) image.src = source;
                };

                setSource('.js-left-sole', sole?.left_sole_side);
                setSource('.js-right-sole', sole?.right_sole_side);
                setSource('.js-charms-left-foot-sole', sole?.left_sole_side);
                setSource('.js-charms-right-foot-sole', sole?.right_sole_side);
                setSource('.js-left-strap', strap?.left_strap_side);
                setSource('.js-right-strap', strap?.right_strap_side);
                setSource('.js-charms-left-foot-strap', strap?.left_strap_side);
                setSource('.js-charms-right-foot-strap', strap?.right_strap_side);

                this.classList.toggle('is-awaiting-sole', !this.activeSole);
                this.classList.toggle('is-awaiting-strap', !this.activeStrap);
                this.updateStepNavigation();
            }

            centerSelectedOption(option, sliderNumber) {
                const slider = this[`soleSlider_${sliderNumber}`];
                if (!slider || !option) return;
                const slides = Array.from(option.parentElement?.children || []).filter(
                    slide => !slide.classList.contains('hidden')
                );
                const index = slides.indexOf(option);
                if (index >= 0) slider.slideTo(index, 220);
            }

            handleSoleSize() {
                let selectedSize = this.flipFlopSize.value;
                let soleColorScript = this.querySelector('.js-sole-color-product');
                if (!soleColorScript || !selectedSize) return;

                let soleData = JSON.parse(soleColorScript.textContent);
                let visibilityChanged = false;

                this.soleColors.forEach(sole => {
                    let colorName = sole.getAttribute('data-sole-color-name');
                    let key = `${selectedSize}-${colorName}`;
                    let shouldShow = soleData.hasOwnProperty(key);
                    let isHidden = sole.classList.contains('hidden');

                    if (shouldShow && isHidden) {
                        sole.classList.remove('hidden');
                        visibilityChanged = true;
                    } else if (!shouldShow && !isHidden) {
                        sole.classList.add('hidden');
                        visibilityChanged = true;
                    }
                });

                if (visibilityChanged) {
                    setTimeout(() => {
                        this.initializeSoleSlider('js-sole-slider', 1);
                    }, 50);
                }

                if (!this.activeSole) return;

                let handleizedSoleName = this.activeSole.getAttribute("data-sole-color-name");
                let scriptKey = `${selectedSize}-${handleizedSoleName}`;

                let soleImageScript = this.querySelector('.js-sole-color-product');
                let imageData = JSON.parse(soleImageScript.textContent);
                
                let variantData = imageData[scriptKey];
                this.selectProductsID = this.selectProductsID.filter(item => !('soleColor' in item || 'soleColorPrice' in item));
                if(variantData && variantData.variant_id) {
                    this.selectProductsID.push(
                        { soleColor: variantData.variant_id },
                        { soleColorPrice: variantData.variant_price }
                    );
                }

                this.updateBaseColorStockStates('sole');
                this.handleTotalPrice();
            }

            handleStrapSize() {
                let selectedSize = this.flipFlopSize.value;
                let strapColorScript = this.querySelector('.js-strap-color-product');
                if (!strapColorScript || !selectedSize) return;

                let strapData = JSON.parse(strapColorScript.textContent);
                let visibilityChanged = false;

                let sizeStrapMapping = this.getStrapSizeMapping();

                this.strapColors.forEach(strap => {
                    let colorName = strap.getAttribute('data-strap-color-name');
                    let key = `${sizeStrapMapping[selectedSize]}-${colorName}`;
                    let shouldShow = strapData.hasOwnProperty(key);
                    let isHidden = strap.classList.contains('hidden');

                    if (shouldShow && isHidden) {
                        strap.classList.remove('hidden');
                        visibilityChanged = true;
                    } else if (!shouldShow && !isHidden) {
                        strap.classList.add('hidden');
                        visibilityChanged = true;
                    }
                });

                if (visibilityChanged) {
                    setTimeout(() => {
                        this.initializeSoleSlider('js-strap-slider', 2);
                    }, 50);
                }

                if (!this.activeStrap) return;

                let handleizedStrapName = this.activeStrap.getAttribute("data-strap-color-name");
                let scriptKey = `${sizeStrapMapping[selectedSize]}-${handleizedStrapName}`;

                let strapImageScript = this.querySelector('.js-strap-color-product');
                let strapImageData = JSON.parse(strapImageScript.textContent);
                
                let variantData = strapImageData[scriptKey];
                this.selectProductsID = this.selectProductsID.filter(item => !('strapColor' in item || 'strapColorPrice' in item || 'strapSize' in item));
                if(variantData && variantData.variant_id) {
                    this.selectProductsID.push(
                        { strapColor: variantData.variant_id },
                        { strapColorPrice: variantData.variant_price },
                        { strapSize: sizeStrapMapping[selectedSize] }
                    );
                }

                this.updateBaseColorStockStates('strap');
                this.handleTotalPrice();
            }

            handleSoleColors(sole) {
                if (!sole || this.isElementOutOfStock(sole)) return;
                if (!this._historyMutationDepth && !this.isRestoringHistory) {
                    return this.mutateWithHistory(() => this.handleSoleColors(sole));
                }

                this.soleColors.forEach(s => {
                    s.classList.remove('active-color');
                    s.setAttribute('aria-pressed', 'false');
                });
                sole.classList.add('active-color');
                sole.setAttribute('aria-pressed', 'true');

                let handlizedSoleColor = sole.getAttribute('data-sole-color-name');
                let soleColor = sole.getAttribute('data-color-name');
                this.soleColorName.innerHTML = soleColor;

                this.activeSole = sole;
                this.classList.remove('is-awaiting-sole');
                this.centerSelectedOption(sole, 1);

                let leftSole = this.querySelector('.js-left-sole');
                let rightSole = this.querySelector('.js-right-sole');
                let leftFootSole = this.querySelector('.js-charms-left-foot-sole');
                let rightFootSole = this.querySelector('.js-charms-right-foot-sole');

                let sizeValue = this.flipFlopSize.value || "";
                let variantData = this.getBaseColorVariant('sole', handlizedSoleColor, sizeValue);

                if (variantData && variantData.left_sole_side && variantData.right_sole_side) {
                    leftSole.src = variantData.left_sole_side;
                    leftFootSole.src = variantData.left_sole_side;
                    rightSole.src = variantData.right_sole_side;
                    rightFootSole.src = variantData.right_sole_side;
                }

                if(sizeValue && variantData && variantData.variant_id) {
                    this.selectProductsID = this.selectProductsID.filter(item => !('soleColor' in item || 'soleColorPrice' in item));
                    this.selectProductsID.push(
                        { soleColor: variantData.variant_id },
                        { soleColorPrice: variantData.variant_price }
                    );
                }

                this.handleTotalPrice();
                this.clearStepMessage();
                this.updateStepNavigation();
            }

            handleStrapColors(strap) {
                if (!strap || this.isElementOutOfStock(strap)) return;
                if (!this._historyMutationDepth && !this.isRestoringHistory) {
                    return this.mutateWithHistory(() => this.handleStrapColors(strap));
                }

                this.strapColors.forEach(s => {
                    s.classList.remove('active-color');
                    s.setAttribute('aria-pressed', 'false');
                });
                strap.classList.add('active-color');
                strap.setAttribute('aria-pressed', 'true');

                let handlizedStrapColor = strap.getAttribute('data-strap-color-name');
                let strapColor = strap.getAttribute('data-color-name');
                this.strapColorName.innerHTML = strapColor;

                this.activeStrap = strap;
                this.classList.remove('is-awaiting-strap');
                this.centerSelectedOption(strap, 2);
                
                let leftStrap = this.querySelector('.js-left-strap');
                let rightStrap = this.querySelector('.js-right-strap');
                let leftFootStrap = this.querySelector('.js-charms-left-foot-strap');
                let rightFootStrap = this.querySelector('.js-charms-right-foot-strap');

                let sizeValue = this.flipFlopSize.value || "";

                let sizeStrapMapping = this.getStrapSizeMapping();
                let variantData = this.getBaseColorVariant('strap', handlizedStrapColor, sizeValue);

                if (variantData && variantData.left_strap_side && variantData.right_strap_side) {
                    leftStrap.src = variantData.left_strap_side;
                    leftFootStrap.src = variantData.left_strap_side;
                    rightStrap.src = variantData.right_strap_side;
                    rightFootStrap.src = variantData.right_strap_side;
                }

                if(sizeValue && variantData && variantData.variant_id) {
                    this.selectProductsID = this.selectProductsID.filter(item => !('strapColor' in item || 'strapColorPrice' in item || 'strapSize' in item));
                    this.selectProductsID.push(
                        { strapColor: variantData.variant_id },
                        { strapColorPrice: variantData.variant_price },
                        { strapSize: sizeStrapMapping[sizeValue] }
                    );
                }

                this.handleTotalPrice();
                this.clearStepMessage();
                this.updateStepNavigation();
            }

            async ensureCharmsCatalog() {
                const handle = this.dataset.charmsCollection;
                if (!handle) return;

                if (this._charmsCatalogLoaded) return;
                if (this._charmsCatalogLoading) {
                    await this._charmsCatalogLoading;
                    return;
                }

                const charmsDataScript = this.querySelector('.js-charms-data');
                const cartDataScript = this.querySelector('.js-charm-cart-data');
                const loadingEl = this.querySelector('.js-charms-loading');
                if (!charmsDataScript || !cartDataScript) return;

                this._charmsCatalogLoading = (async () => {
                    try {
                        loadingEl?.classList.remove('visually-hidden');

                        let mergedCharms = {};
                        const existing = JSON.parse(charmsDataScript.textContent || '{}');
                        if (existing['none--0']) mergedCharms['none--0'] = existing['none--0'];

                        let mergedCart = {};
                        let page = 1;
                        let hasNext = true;

                        while (hasNext) {
                            const url = `/collections/${encodeURIComponent(handle)}?section_id=bundle-charms-catalog&page=${page}`;
                            const response = await fetch(url);
                            if (!response.ok) {
                                throw new Error(`Unable to load charms (${response.status})`);
                            }

                            const html = await response.text();
                            const doc = new DOMParser().parseFromString(html, 'text/html');
                            const catalogRoot = doc.querySelector('[data-charms-catalog]');
                            const pageCharmsScript = doc.querySelector('.js-charms-data');
                            const pageCartScript = doc.querySelector('.js-charm-cart-data');

                            if (!pageCharmsScript) break;

                            const pageCharms = JSON.parse(pageCharmsScript.textContent || '{}');
                            Object.assign(mergedCharms, pageCharms);

                            if (pageCartScript) {
                                const pageCart = JSON.parse(pageCartScript.textContent || '{}');
                                Object.assign(mergedCart, pageCart);
                            }

                            hasNext = catalogRoot?.dataset.hasNextPage === 'true';
                            page += 1;
                        }

                        charmsDataScript.textContent = JSON.stringify(mergedCharms);
                        cartDataScript.textContent = JSON.stringify(mergedCart);
                        this._charmsCatalogLoaded = true;
                        this.arrangeCharms();
                    } catch (error) {
                        console.error('Failed to load charm catalog', error);
                        this.showStepMessage('Unable to load charms. Please refresh and try again.');
                    } finally {
                        loadingEl?.classList.add('visually-hidden');
                        this._charmsCatalogLoading = null;
                    }
                })();

                await this._charmsCatalogLoading;
            }

            async ensureRibbonsCatalog() {
                const handle = this.dataset.ribbonsCollection;
                if (!handle) return;

                if (this._ribbonsCatalogLoaded) return;
                if (this._ribbonsCatalogLoading) {
                    await this._ribbonsCatalogLoading;
                    return;
                }

                const wrapper = this.querySelector('.ribbons-tabs .swiper-wrapper');
                const cartDataScript = this.querySelector('.js-ribbon-cart-data');
                const loadingEl = this.querySelector('.js-ribbons-loading');
                if (!wrapper || !cartDataScript) return;

                this._ribbonsCatalogLoading = (async () => {
                    try {
                        loadingEl?.classList.remove('visually-hidden');

                        let mergedCart = {};
                        let page = 1;
                        let hasNext = true;

                        while (hasNext) {
                            const url = `/collections/${encodeURIComponent(handle)}?section_id=bundle-ribbons-catalog&page=${page}`;
                            const response = await fetch(url);
                            if (!response.ok) {
                                throw new Error(`Unable to load ribbons (${response.status})`);
                            }

                            const html = await response.text();
                            const doc = new DOMParser().parseFromString(html, 'text/html');
                            const catalogRoot = doc.querySelector('[data-ribbons-catalog]');
                            const slidesContainer = doc.querySelector('.js-ribbons-catalog-slides');
                            const pageCartScript = doc.querySelector('.js-ribbon-cart-data');

                            if (slidesContainer) {
                                slidesContainer.querySelectorAll('.js-flip-flop-ribbon').forEach((slide) => {
                                    wrapper.appendChild(document.importNode(slide, true));
                                });
                            }

                            if (pageCartScript) {
                                const pageCart = JSON.parse(pageCartScript.textContent || '{}');
                                Object.assign(mergedCart, pageCart);
                            }

                            hasNext = catalogRoot?.dataset.hasNextPage === 'true';
                            page += 1;
                        }

                        cartDataScript.textContent = JSON.stringify(mergedCart);
                        this._ribbonsCatalogLoaded = true;
                        this.bindRibbonListeners();
                        this._resetAllRibbonSlides();
                    } catch (error) {
                        console.error('Failed to load ribbon catalog', error);
                        this.showStepMessage('Unable to load ribbons. Please refresh and try again.');
                    } finally {
                        loadingEl?.classList.add('visually-hidden');
                        this._ribbonsCatalogLoading = null;
                    }
                })();

                await this._ribbonsCatalogLoading;
            }

            arrangeCharms() {
                let charmsContainer = this.querySelector(".js-charms-container");
                let charmsDataScript = this.querySelector(".js-charms-data");

                if (!charmsContainer || !charmsDataScript) return;

                let charmsData = JSON.parse(charmsDataScript.textContent);
                charmsContainer.innerHTML = "";

                Object.entries(charmsData).forEach(([key, charmHTML]) => {
                    let tempWrapper = document.createElement("div");
                    tempWrapper.innerHTML = charmHTML;
                    let slide = tempWrapper.firstElementChild;
                    if (slide && !slide.classList.contains('hidden')) {
                        charmsContainer.appendChild(slide);
                    }
                });
                this.bindEventListeners();
                this.applyStockStateToSlides(this.prodCharms);
            }

            applyStockStateToSlides(slides) {
                if (!slides || !slides.length) return;
                slides.forEach(slide => {
                    if (this.isElementOutOfStock(slide)) {
                        slide.classList.add('is-out-of-stock');
                        slide.setAttribute('aria-disabled', 'true');
                    }
                });
            }

            bindEventListeners() {
                this.prodCharms = this.querySelectorAll('.js-flip-flop-charm');
                this.clearCharmsBtn = this.querySelector('.js-clear-charms');

                if (this.clearCharmsBtn && !this.clearCharmsBtn.dataset.bound) {
                    this.clearCharmsBtn.addEventListener('click', () => {
                        this.clearCharms();
                    });
                    this.clearCharmsBtn.dataset.bound = "true";
                }

                this.prodCharms.forEach((charm) => {
                    if (!charm.dataset.bound) {
                        charm.addEventListener('click', () => {
                            if (this.isElementOutOfStock(charm)) return;
                            if (charm.classList.contains('js-clear-charms')) {
                                this.activeCharm = null;
                                this.updateCharmPositionAvailability();
                                return;
                            }
                            if (this.getCharmRequiredPositions(charm) === 4) {
                                this.autoPlaceFourSlotCharm(charm);
                                return;
                            }
                            this.selectCharmOption(charm);
                            this.activeCharm = charm;
                            this.placeCharms(charm);
                        });
                        charm.dataset.bound = "true";
                    }
                });
            }

            charmImageZoom(charm) {
                let imageZoomWrapper = this.querySelector('.js-charm-img-zoom');
                let tabWrapper = this.querySelector('.js-tab-wrapper');
                if(!charm || !imageZoomWrapper || !tabWrapper) return;

                imageZoomWrapper.classList.remove("hidden");
                let zoomInnerImage = imageZoomWrapper.querySelector('.js-inner-zoom-img');
                let charmImageWrapper = charm.querySelector('img');
                let charmImageSrc = charmImageWrapper.getAttribute('src')

                let charmRect = charm.getBoundingClientRect();
                let containerRect = tabWrapper.getBoundingClientRect();

                let top = charmRect.top - containerRect.top;
                let left = charmRect.left - containerRect.left;

                zoomInnerImage.style.backgroundImage = `url("${charmImageSrc}")`;
                imageZoomWrapper.style.top = `${top}px`;
                imageZoomWrapper.style.left = `${left}px`;
            }

            setFilters() {
                let themeFilterBtn = this.querySelector('.js-theme-filter-btn');
                let themeFilter = this.querySelector('.js-theme-filter-charm');
                let colorFilterBtn = this.querySelector('.js-color-filter-btn');
                let colorFilter = this.querySelector('.js-color-filter-charm');
                let selectedFiltersWrapper = this.querySelector('.js-selected-filters');
                
                let charmsContainer = this.querySelector(".js-charms-container");
                if (charmsContainer) {
                    charmsContainer.addEventListener('mouseleave', () => {
                        this.querySelector('.js-charm-img-zoom')?.classList.add("hidden")
                    })
                }

                if (themeFilterBtn && themeFilter) {
                    themeFilterBtn.addEventListener('click', () => {
                        themeFilter.classList.toggle('hidden');
                        themeFilterBtn.classList.toggle('active');
                        if(colorFilter && !colorFilter.classList.contains('hidden')) colorFilter.classList.add('hidden');
                        if(colorFilterBtn && colorFilterBtn.classList.contains('active')) colorFilterBtn.classList.remove('active');
                    });
                }

                if (colorFilterBtn && colorFilter) {
                    colorFilterBtn.addEventListener('click', () => {
                        colorFilter.classList.toggle('hidden');
                        colorFilterBtn.classList.toggle('active');
                        if(themeFilter && !themeFilter.classList.contains('hidden')) themeFilter.classList.add('hidden');
                        if(themeFilterBtn && themeFilterBtn.classList.contains('active')) themeFilterBtn.classList.remove('active');
                    });
                }

                this.querySelector('.js-charm-search')?.addEventListener('input', () => {
                    this.applyFilters();
                });

                if(this.filters.length > 0) {
                    this.filters.forEach((filter) => {
                        filter.addEventListener('click', () => {
                            filter.classList.add('active', 'hidden');
                            this.applyFilters();

                            let dataFilter = filter.getAttribute('data-filter');
                            
                            let selectedButton = document.createElement('button');
                            selectedButton.classList.add('js-selected-filter');
                            selectedButton.setAttribute('data-filter', dataFilter);
                            selectedButton.innerHTML = `${filter.innerHTML} <span class="remove-filter">X</span>`;
                            selectedFiltersWrapper.appendChild(selectedButton);

                            if(selectedFiltersWrapper.classList.contains('hidden')) selectedFiltersWrapper.classList.remove('hidden');
                            if(themeFilter) themeFilter.classList.add('hidden');
                            if(themeFilterBtn) themeFilterBtn.classList.remove('active');
                            if(colorFilter) colorFilter.classList.add('hidden');
                            if(colorFilterBtn) colorFilterBtn.classList.remove('active');

                            selectedButton.addEventListener('click', () => {
                                selectedButton.remove();
                                let originalFilter = this.querySelector(`.charms-tabs .js-filter[data-filter="${dataFilter}"]`);
                                if (originalFilter) {
                                    originalFilter.classList.remove('active', 'hidden');
                                }
                                this.applyFilters();

                                if (selectedFiltersWrapper.children.length === 0) {
                                    selectedFiltersWrapper.classList.add('hidden');
                                }
                            });
                        });
                    });
                }
            }

            setRibbonFilters() {
                // Guard – hardware‑filter UI must exist
                if (!this.ribbonHardwareFilterBtn || !this.ribbonHardwareFilter) return;

                // Toggle hardware‑filter drawer
                this.ribbonHardwareFilterBtn.addEventListener('click', () => {
                    this.ribbonHardwareFilter.classList.toggle('hidden');
                    this.ribbonHardwareFilterBtn.classList.toggle('active');
                });

                // Initialise any pre‑selected UI state
                this._resetAllRibbonSlides();

                // Attach click handlers to each filter button
                if (this.ribbonFilters.length) {
                    this.ribbonFilters.forEach(filter => {
                        filter.addEventListener('click', () => {
                            // Visually hide the filter and mark it active
                            filter.classList.add('active', 'hidden');

                            // Refresh the ribbon grid
                            this.applyRibbonFilters();

                            // Create “selected” filter chip
                            const dataFilter = filter.getAttribute('data-filter');
                            const selectedBtn = document.createElement('button');
                            selectedBtn.classList.add('js-ribbon-selected-filter');
                            selectedBtn.setAttribute('data-filter', dataFilter);
                            selectedBtn.innerHTML = `${filter.innerHTML} <span class="remove-filter">X</span>`;

                            // Append to the wrapper and ensure wrapper is visible
                            if (this.ribbonSelectedFiltersWrapper) {
                                this.ribbonSelectedFiltersWrapper.appendChild(selectedBtn);
                                this.ribbonSelectedFiltersWrapper.classList.remove('hidden');
                            }

                            // Close hardware drawer
                            this.ribbonHardwareFilter.classList.add('hidden');
                            this.ribbonHardwareFilterBtn.classList.remove('active');

                            // Removal handler – restores original filter button
                            selectedBtn.addEventListener('click', () => {
                                selectedBtn.remove();
                                const original = this.querySelector(`.ribbons-tabs .js-ribbon-filter[data-filter="${dataFilter}"]`);
                                if (original) original.classList.remove('active', 'hidden');
                                this.applyRibbonFilters();

                                // Hide wrapper when empty
                                if (this.ribbonSelectedFiltersWrapper && !this.ribbonSelectedFiltersWrapper.children.length) {
                                    this.ribbonSelectedFiltersWrapper.classList.add('hidden');
                                }
                            });
                        });
                    });
                }
            }

            /** Reset all ribbon slides to visible – called on init & on clear */
            _resetAllRibbonSlides() {
                const slides = this.querySelectorAll('.ribbons-tabs .js-flip-flop-ribbon');
                slides.forEach(slide => {
                    slide.classList.remove('hidden');
                    slide.classList.add('swiper-slide');
                });
                if (this.gridSlider_2) {
                    this.gridSlider_2.update();
                    this.gridSlider_2.slideTo(0);
                }
            }

            applyRibbonFilters() {
                if (this.dataset.ribbonsCollection && !this._ribbonsCatalogLoaded) return;

                const activeFilters = Array.from(this.ribbonFilters)
                    .filter(btn => btn.classList.contains('active'))
                    .map(btn => btn.getAttribute('data-filter').toLowerCase());

                // Query by the custom ribbon class, NOT .swiper-slide, since we remove that class to hide items.
                const slides = this.querySelectorAll('.ribbons-tabs .js-flip-flop-ribbon:not(.js-remove-ribbon)');

                slides.forEach(slide => {
                    const labels = (slide.getAttribute('data-filter-labels') || '')
                        .split(',')
                        .map(l => l.trim().toLowerCase());

                    const shouldShow = !activeFilters.length ||
                        activeFilters.some(f => labels.includes(f));

                    if (shouldShow) {
                        slide.classList.remove('hidden');
                        slide.classList.add('swiper-slide');
                    } else {
                        slide.classList.add('hidden');
                        slide.classList.remove('swiper-slide');
                    }
                });

                // Refresh the Swiper instance for ribbons
                if (this.gridSlider_2) {
                    this.gridSlider_2.update();
                    this.gridSlider_2.slideTo(0);
                }
            }


            selectCharmOption(charm) {
                this.prodCharms?.forEach(option => {
                    const selected = option === charm;
                    option.classList.toggle('active', selected);
                    option.setAttribute('aria-pressed', String(selected));
                });
            }

            clearActiveChainSelection() {
                if (this.getCharmRequiredPositions(this.activeCharm) !== 4) return;
                this.activeCharm?.classList.remove('active');
                this.activeCharm?.setAttribute('aria-pressed', 'false');
                this.activeCharm = null;
                this.activeCharmPosition = null;
                this.classList.remove('is-chain-auto-placement');
            }

            getCanonicalFourSlotGroup(footSide) {
                const indices = footSide === 'left' ? [1, 2, 3, 4] : [11, 12, 13, 14];
                const anchorIndex = footSide === 'left' ? 1 : 12;
                return {
                    footSide,
                    indices,
                    anchorIndex,
                    positions: indices.map(index => this.getCharmPositionByIndex(index)).filter(Boolean),
                    anchor: this.getCharmPositionByIndex(anchorIndex)
                };
            }

            autoPlaceFourSlotCharm(charm) {
                const selectedFoot = this.querySelector('.js-charm-image:not(.hidden)');
                const footSide = selectedFoot?.getAttribute('data-foot-side');
                if (!footSide) return false;
                const group = this.getCanonicalFourSlotGroup(footSide);
                const available = group.positions.length === 4 && group.positions.every(
                    position => !position.classList.contains('js-is-not-empty')
                );

                if (!available) {
                    this.handleNoPositionPopup();
                    return false;
                }

                if (!this.isRestoringHistory && !this._historyMutationDepth) {
                    this._lastCommittedState = this.captureConfiguratorState();
                }
                return this.mutateWithHistory(() => {
                    this.selectCharmOption(charm);
                    this.activeCharm = charm;
                    this.activeCharmPosition = null;
                    this.insertPopup?.classList.add('hidden');
                    this.placeCharms(charm, { silent: true });
                    this.insertBiggerCharm(group.anchor);
                    return true;
                });
            }

            getCharmRequiredPositions(charm = this.activeCharm) {
                const required = parseInt(charm?.getAttribute('data-position-required') || '1', 10);
                return [1, 2, 3, 4].includes(required) ? required : 1;
            }

            getCharmPositionByIndex(index) {
                return Array.from(this.charmPositions || []).find(
                    position => Number(position.getAttribute('data-position-index')) === Number(index)
                ) || null;
            }

            getCharmRunForPosition(position, charm = this.activeCharm) {
                if (!position || !charm || charm.classList.contains('js-clear-charms')) return [];
                const required = this.getCharmRequiredPositions(charm);
                const index = Number(position.getAttribute('data-position-index'));
                const footSide = position.getAttribute('data-foot-side');

                if (required === 1) return [position];

                if (required === 2) {
                    const pairMap = {
                        1: [1, 2], 3: [2, 3], 5: [5, 6], 7: [6, 7],
                        8: [8, 9], 10: [9, 10], 12: [12, 13], 14: [13, 14]
                    };
                    return (pairMap[index] || []).map(slot => this.getCharmPositionByIndex(slot)).filter(Boolean);
                }

                if (required === 3) {
                    const runs = footSide === 'left'
                        ? [[1, 2, 3], [5, 6, 7]]
                        : [[8, 9, 10], [12, 13, 14]];
                    const run = runs.find(indices => indices.includes(index)) || [];
                    return run.map(slot => this.getCharmPositionByIndex(slot)).filter(Boolean);
                }

                const group = this.getCanonicalFourSlotGroup(footSide);
                if (!group.indices.includes(index)) return [];
                return group.positions;
            }

            checkSpaceBetweenCharms(position, charm = this.activeCharm) {
                const required = this.getCharmRequiredPositions(charm);
                if (required > 1 && !this.isCharmPlacementAnchor(position, charm)) return false;
                const run = this.getCharmRunForPosition(position, charm);
                return run.length === required && run.every(
                    slot => !slot.classList.contains('js-is-not-empty')
                );
            }

            isCharmPlacementAnchor(position, charm = this.activeCharm) {
                if (!position || !charm) return false;
                const required = this.getCharmRequiredPositions(charm);
                const index = Number(position.getAttribute('data-position-index'));
                if (required === 1) return true;
                if (required === 2) return [1, 3, 5, 7, 8, 10, 12, 14].includes(index);
                if (required === 3) return [1, 5, 8, 12].includes(index);
                return index === this.getCanonicalFourSlotGroup(
                    position.getAttribute('data-foot-side')
                ).anchorIndex;
            }

            getPrimaryCharmPosition(position) {
                if (!position) return null;
                const required = Number(position.getAttribute('data-space-required') || 1);
                const index = Number(position.getAttribute('data-position-index'));
                let primaryIndex = index;

                if (required === 4) {
                    primaryIndex = this.getCanonicalFourSlotGroup(
                        position.getAttribute('data-foot-side')
                    ).anchorIndex;
                } else if (required === 3) {
                    const primaryMap = {
                        1: 1, 2: 1, 3: 1, 5: 5, 6: 5, 7: 5,
                        8: 8, 9: 8, 10: 8, 12: 12, 13: 12, 14: 12
                    };
                    primaryIndex = primaryMap[index] || index;
                } else if (required === 2) {
                    const ownerClass = Array.from(position.classList).find(
                        className => className.startsWith('js-double-spaced-charm-')
                    );
                    if (ownerClass) primaryIndex = Number(ownerClass.split('-').pop()) || index;
                }

                return this.getCharmPositionByIndex(primaryIndex) || position;
            }

            setCharmPositionDisabled(position, disabled, title = '') {
                position.disabled = Boolean(disabled);
                position.setAttribute('aria-disabled', String(Boolean(disabled)));
                if (title) position.setAttribute('title', title);
                else position.removeAttribute('title');
            }

            getCharmGroupId(position, required) {
                const primary = this.getPrimaryCharmPosition(position) || position;
                return [
                    position.getAttribute('data-foot-side'),
                    required,
                    primary.getAttribute('data-position-index')
                ].join('-');
            }

            setCharmGroupEmphasis(position, emphasized) {
                const groupId = position?.getAttribute('data-charm-group');
                if (!groupId) return;
                this.charmPositions.forEach(slot => {
                    if (slot.getAttribute('data-charm-group') === groupId) {
                        slot.classList.toggle('js-group-emphasized', emphasized);
                    }
                });
            }

            updateMultiSlotEducation(required, selectedFoot) {
                const education = this.querySelector('.js-charm-space-education');
                const guidance = this.querySelector('.js-charm-space-guidance');
                const usage = this.querySelector('.js-charm-space-usage');
                if (!education || !guidance || !usage) return;

                if (required <= 1 || !this.activeCharm) {
                    education.classList.add('hidden');
                    guidance.textContent = '';
                    usage.textContent = '';
                    return;
                }

                const noun = required === 4 ? 'chain' : 'charm';
                const usedOnFoot = Array.from(this.charmPositions).filter(position => (
                    position.getAttribute('data-foot-side') === selectedFoot
                    && position.classList.contains('js-is-not-empty')
                    && Number(position.getAttribute('data-space-required')) === required
                )).length;
                const hasAvailableGroup = Array.from(this.charmPositions).some(
                    position => position.classList.contains('js-group-anchor')
                        && position.classList.contains('js-is-available')
                );

                education.classList.remove('hidden');
                if (usedOnFoot >= required) {
                    guidance.textContent = required === 4
                        ? `Chain added to the four available spaces on the ${selectedFoot} foot.`
                        : `This ${noun} uses ${required} adjacent charm spaces.`;
                    usage.textContent = `${required} spaces used. Select the grouped ${noun} on the shoe to remove it.`;
                } else if (hasAvailableGroup) {
                    guidance.textContent = `This ${noun} uses ${required} adjacent charm spaces. Choose a highlighted group.`;
                    usage.textContent = '';
                } else {
                    guidance.textContent = `This ${noun} uses ${required} adjacent charm spaces.`;
                    usage.textContent = `No ${required}-space group is available on this foot. Remove a charm or switch feet.`;
                }
            }

            updateCharmPositionAvailability() {
                const selectedFoot = this.querySelector('.js-charm-image:not(.hidden)')?.getAttribute('data-foot-side');
                const required = this.getCharmRequiredPositions(this.activeCharm);
                this.classList?.toggle('is-chain-auto-placement', required === 4);
                this.charmPositions.forEach(position => {
                    const occupied = position.classList.contains('js-is-not-empty');
                    position.classList.remove(
                        'js-is-available', 'js-forbidden-slot', 'js-group-anchor',
                        'js-group-member', 'js-group-preview', 'js-group-reserved',
                        'js-group-emphasized', 'js-chain-auto-hidden'
                    );
                    position.removeAttribute('data-charm-group');

                    if (occupied) {
                        position.classList.remove('js-is-empty');
                        const occupiedRequired = Number(position.getAttribute('data-space-required') || 1);
                        if (occupiedRequired > 1) {
                            const primary = this.getPrimaryCharmPosition(position);
                            const isPrimary = primary === position;
                            const groupId = this.getCharmGroupId(position, occupiedRequired);
                            position.classList.add('js-group-reserved');
                            position.classList.toggle('js-group-anchor', isPrimary);
                            position.classList.toggle('js-group-member', !isPrimary);
                            position.setAttribute('data-charm-group', groupId);
                            this.setCharmPositionDisabled(
                                position,
                                !isPrimary,
                                isPrimary
                                    ? `${occupiedRequired} spaces used. Select to remove this charm.`
                                    : `Reserved by a ${occupiedRequired}-space charm. Use the grouped anchor to remove it.`
                            );
                        } else {
                            this.setCharmPositionDisabled(position, false, 'Charm placed. Select to edit or remove.');
                        }
                        return;
                    }

                    if (!this.activeCharm || this.activeCharm.classList.contains('js-clear-charms')) {
                        position.classList.add('js-is-empty');
                        this.setCharmPositionDisabled(position, false);
                        return;
                    }

                    const onSelectedFoot = position.getAttribute('data-foot-side') === selectedFoot;
                    if (!onSelectedFoot) {
                        position.classList.add('js-is-empty');
                        this.setCharmPositionDisabled(position, true);
                        return;
                    }

                    if (required === 4) {
                        position.classList.add('js-is-empty', 'js-chain-auto-hidden');
                        this.setCharmPositionDisabled(
                            position,
                            true,
                            'Four-space chains are placed automatically from the product card.'
                        );
                        return;
                    }

                    if (required === 1) {
                        position.classList.remove('js-is-empty');
                        position.classList.add('js-is-available');
                        this.setCharmPositionDisabled(position, false, 'Place charm here.');
                        return;
                    }

                    const isAnchor = this.isCharmPlacementAnchor(position, this.activeCharm);
                    position.classList.add('js-is-empty');
                    position.classList.add('js-forbidden-slot');
                    this.setCharmPositionDisabled(
                        position,
                        true,
                        isAnchor
                            ? `Needs ${required} adjacent empty charm spaces.`
                            : `Part of a ${required}-space placement group. Choose its highlighted anchor.`
                    );
                });

                if (required > 1 && required !== 4 && this.activeCharm) {
                    this.charmPositions.forEach(position => {
                        const onSelectedFoot = position.getAttribute('data-foot-side') === selectedFoot;
                        if (!onSelectedFoot
                            || position.classList.contains('js-is-not-empty')
                            || !this.isCharmPlacementAnchor(position, this.activeCharm)
                            || !this.checkSpaceBetweenCharms(position, this.activeCharm)) return;

                        const run = this.getCharmRunForPosition(position, this.activeCharm);
                        const groupId = [
                            selectedFoot,
                            required,
                            position.getAttribute('data-position-index')
                        ].join('-');
                        run.forEach(slot => {
                            slot.classList.remove('js-is-empty', 'js-forbidden-slot');
                            slot.classList.add('js-group-preview');
                            slot.classList.toggle('js-group-anchor', slot === position);
                            slot.classList.toggle('js-group-member', slot !== position);
                            slot.setAttribute('data-charm-group', groupId);
                            this.setCharmPositionDisabled(
                                slot,
                                slot !== position,
                                slot === position
                                    ? `Place ${required}-space ${required === 4 ? 'chain' : 'charm'} in this highlighted group.`
                                    : `Included in this ${required}-space placement group.`
                            );
                            if (slot === position) slot.classList.add('js-is-available');
                        });
                    });
                }
                this.updateMultiSlotEducation(required, selectedFoot);
            }

            refreshCharmPlacementPreviews() {
                if (!this.activeCharm || this.activeCharm.classList.contains('js-clear-charms')) {
                    this.updateCharmPositionAvailability();
                    return;
                }
                if (!this.querySelector('.js-charm-image:not(.hidden)')) return;
                this.placeCharms(this.activeCharm, { silent: true });
            }

            placeCharms(charm, { silent = false } = {}) {
                if (this.isElementOutOfStock(charm)) return;

                let selectedFootImg = this.querySelector('.js-charm-image:not(.hidden)');
                let selectedfootSide = selectedFootImg.getAttribute('data-foot-side');
                if(!this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.add('hidden');

                let charmName = this.querySelector('.js-charm-name');
                let charmId = charm.getAttribute("data-charm-variant-id");
                let charmPrice = charm.getAttribute('data-charm-variant-price');
                let variantName = charm.getAttribute('data-charm-variant-title');
                charmName.innerHTML = variantName;

                if(charm.classList.contains('js-clear-charms')) return;

                let containers = [
                    selectedFootImg.querySelector('.js-charm-c1'),
                    selectedFootImg.querySelector('.js-charm-c2'),
                    selectedFootImg.querySelector('.js-charm-c3'),
                    selectedFootImg.querySelector('.js-charm-c4'),
                    selectedFootImg.querySelector('.js-charm-c5'),
                    selectedFootImg.querySelector('.js-charm-c6'),
                    selectedFootImg.querySelector('.js-charm-c7')
                ];

                containers.forEach(container => {
                    if (!container.classList.contains('js-charms-added')) {
                        container.src = "";
                        container.style.opacity = '0.3';
                        container.style.cursor = 'default';
                        if(container.classList.contains('charm-bigger-image')) container.classList.remove('charm-bigger-image');
                    }
                });
                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.classList.add('js-is-empty');
                        position.removeAttribute('data-space-required');
                    } 
                });

                let charmReqPositon = charm.getAttribute('data-position-required');
                if(charmReqPositon == "4") {
                    this.rotateCharm?.classList.add('hidden');
                    this.handleBiggerCharms(charm, containers, selectedFootImg, variantName, charmId, charmPrice, silent);
                    return;
                }
                this?.rotateCharm?.classList.remove('hidden');

                let charmImage = charm.querySelector('img');
                if (!charmImage) return;
                let imageSrc = charmImage.getAttribute('src');
                
                if (charmReqPositon == "2") {
                    let isLeft = selectedfootSide === "left";
                    let baseIndex = isLeft ? 0 : 7;
                    let pos1 = baseIndex + 1;
                    let pos5 = baseIndex + 5;
                    let dynamicMapping = {
                        [pos1]: [0, 2],
                        [pos5]: [4, 6]
                    };
                    
                    let posA = isLeft ? 1 : 8;
                    let posB = isLeft ? 5 : 12;
                    
                    let positionsToCheck = isLeft ? [0, 1, 2, 4, 5, 6] : [7, 8, 9, 11, 12, 13];
                    let allFilled = positionsToCheck.every(index =>
                        this.charmPositions[index]?.classList.contains('js-is-not-empty')
                    );

                    let isBlocked = (index) => {
                        let pos = this.charmPositions[index];
                        if (!pos) return false;

                        let hasNotEmpty = pos.classList.contains('js-is-not-empty');
                        let doubleSpacedClasses = Array.from(pos.classList).filter(cls =>
                            cls.startsWith('js-double-spaced-charm')
                        );

                        return (
                            hasNotEmpty &&
                            (doubleSpacedClasses.length === 0 || doubleSpacedClasses.length === 2)
                        );
                    };

                    let isOnePlaceFilled = (index) => {
                        let pos = this.charmPositions[index];
                        if (!pos) return false;

                        let minusOneIndex = this.charmPositions[index - 1].classList.contains('js-is-not-empty');
                        let PlusOneIndex = this.charmPositions[index + 1].classList.contains('js-is-not-empty');
                        let doubleSpacedClasses = Array.from(pos.classList).filter(cls =>
                            cls.startsWith('js-double-spaced-charm')
                        );

                        return (minusOneIndex && PlusOneIndex && (doubleSpacedClasses.length === 0 || doubleSpacedClasses.length === 1));
                    }
                    
                    if ((isBlocked(posA) && isBlocked(posB)) || allFilled || (isOnePlaceFilled(posA) && isOnePlaceFilled(posB)) || 
                        (isBlocked(posA) && isOnePlaceFilled(posB)) || (isBlocked(posB) && isOnePlaceFilled(posA))
                    ) {
                        this.updateCharmPositionAvailability();
                        return;
                    }

                    for (let pos in dynamicMapping) {
                        pos = parseInt(pos);
                        let hasCharmClass = Array.from(this.charmPositions[pos]?.classList).some(cls => cls.startsWith('js-double-spaced-charm'));
                        if (!this.charmPositions[pos]?.classList.contains('js-is-not-empty') || hasCharmClass) {
                            dynamicMapping[pos].forEach(index => {
                                let container = containers[index];
                                if (container && !container.classList.contains('js-charms-added')) {
                                    container.src = imageSrc;
                                    container.style.opacity = '0.3';
                                    container.style.cursor = 'pointer';
                                    container.setAttribute("data-charm-name", variantName);
                                    container.setAttribute("data-charm-id", charmId);
                                    container.setAttribute("data-charm-price", charmPrice);

                                    let charmPos = this.charmPositions[index + baseIndex];
                                    if (charmPos?.classList.contains('js-is-empty')) {
                                        charmPos.classList.remove('js-is-empty');
                                        charmPos.setAttribute('data-space-required', charmReqPositon);
                                    }
                                }
                            });
                        }
                    }
                }
                else {
                    let isLeft = selectedfootSide === "left";
                    let isSide3Blocked = (sideIndex) => {
                        let base = isLeft ? 0 : 7;
                        let offset = sideIndex === 0 ? 0 : 4;
                        let indicesToCheck = [base + offset, base + offset + 1, base + offset + 2];
                        return indicesToCheck.some(idx => this.charmPositions[idx]?.classList.contains('js-is-not-empty'));
                    };

                    if (charmReqPositon == "3" && isSide3Blocked(0) && isSide3Blocked(4)) {
                        this.updateCharmPositionAvailability();
                        return;
                    }

                    containers.forEach((container, index) => {
                        if(charmReqPositon == "3") {
                            if(index != 0 && index != 4) return;
                            if(isSide3Blocked(index)) return;
                        }
                        if (!container.classList.contains('js-charms-added')) {
                            container.src = imageSrc;
                            container.style.opacity = '0.3';
                            container.style.cursor = 'pointer';
                            container.setAttribute("data-charm-name", variantName);
                            container.setAttribute("data-charm-id", charmId);
                            container.setAttribute("data-charm-price", charmPrice);
                        }
                    });

                    this.charmPositions.forEach((position, index) => {
                        position.classList.remove('js-forbidden-slot');
                        let isLeft = selectedfootSide === "left";
                        let side1Indices = isLeft ? [0, 1, 2] : [7, 8, 9];
                        let side2Indices = isLeft ? [4, 5, 6] : [11, 12, 13];

                        if(charmReqPositon == "3") {
                            let isSide1Allowed = !isSide3Blocked(0);
                            let isSide2Allowed = !isSide3Blocked(4);

                            if(side1Indices.includes(index) && isSide1Allowed) {
                                position.classList.remove('js-is-empty');
                                position.setAttribute('data-space-required', charmReqPositon);
                            } else if(side2Indices.includes(index) && isSide2Allowed) {
                                position.classList.remove('js-is-empty');
                                position.setAttribute('data-space-required', charmReqPositon);
                            }
                            return;
                        }


                        if(position.classList.contains('js-is-empty')) {
                            position.classList.remove('js-is-empty');
                            position.setAttribute('data-space-required', charmReqPositon);
                        } 
                    });
                }
                this.updateCharmPositionAvailability();
            }

            handleBiggerCharms(charm, containers, selectedFootImg, variantName, charmId, charmPrice, silent = false) {
                let footSide = selectedFootImg.getAttribute('data-foot-side');
                let isLeft = footSide === "left";
                let imageSrc = charm.getAttribute(isLeft ? 'data-left-src' : 'data-right-src');
                const group = this.getCanonicalFourSlotGroup(footSide);
                let allEmpty = group.positions.length === 4 && group.positions.every(
                    pos => !pos.classList.contains('js-is-not-empty')
                );
                
                if (allEmpty) {
                    let container = Array.from(containers).find(
                        item => item.getAttribute('data-position') === group.anchor?.getAttribute('data-position')
                    );
                    if (!container) return;
                    container.src = imageSrc;
                    container.style.opacity = '0.3';
                    container.style.cursor = 'pointer';
                    container.classList.add('charm-bigger-image');
                    container.setAttribute("data-charm-name", variantName);
                    container.setAttribute("data-charm-id", charmId);
                    container.setAttribute("data-charm-price", charmPrice);

                    group.positions.forEach(pos => {
                        pos.classList.remove('js-is-empty');
                        pos.setAttribute('data-space-required', "4");
                    });
                }
                this.updateCharmPositionAvailability();
            }

            handleNoPositionPopup() {
                let noCharmSpacePopup = this.querySelector(".js-no-space-popup");
                if (noCharmSpacePopup && this.bundleWrapper) {
                    this.openModal(noCharmSpacePopup);
                }
            }

            clearCharms() {
                if (!this._historyMutationDepth && !this.isRestoringHistory) {
                    return this.mutateWithHistory(() => this.clearCharms());
                }
                let charmName = this.querySelector('.js-charm-name');
                charmName.innerHTML = "None";
                this.charmPositions.forEach((position) => {
                    position.classList.add('js-is-empty');
                    position.classList.remove('js-is-not-empty', 'js-forbidden-slot');
                    position.removeAttribute('data-space-required');

                    Array.from(position.classList).forEach(cls => {
                        if (cls.startsWith('js-double-spaced-charm') || cls.startsWith('js-triple-spaced-charm')) {
                            position.classList.remove(cls);
                        }
                    });
                });
                this.charms.forEach((charm) => {
                    charm.classList.remove('js-charms-added', 'charm-bigger-image');
                    charm.src = "";
                    charm.removeAttribute('data-rotation');
                    charm.removeAttribute('data-charm-name');
                    charm.removeAttribute('data-charm-id');
                    charm.removeAttribute('data-charm-price');
                    charm.removeAttribute('style');
                    charm.style.opacity = '0.3';
                    charm.style.cursor = 'default';
                });
                this.mainImageCharms.forEach((charmImg) => {
                    charmImg.src = "";
                    charmImg.classList.remove('charm-bigger-image');
                    charmImg.removeAttribute('data-rotation');
                    charmImg.removeAttribute('style');
                })
                this.charmsProductID = [];
                this.activeCharm = null;
                this.activeCharmPosition = null;

                this.prodCharms?.forEach(c => {
                    c.classList.remove('active');
                    c.setAttribute('aria-pressed', 'false');
                });
                this.clearCharmsBtn?.classList.add('active');
                this.clearCharmsBtn?.setAttribute('aria-pressed', 'true');
                this.updateCharmPositionAvailability();

                this.handleTotalPrice();
            }

            handleCharms(position) {
                if (!position.classList.contains('js-is-not-empty')
                    && !this.checkSpaceBetweenCharms(position, this.activeCharm)) return;
                if(this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.remove('hidden');
                this.activeCharmPosition = position;
            }

            insertSelectedCharm(position) {
                if (!this._historyMutationDepth && !this.isRestoringHistory) {
                    return this.mutateWithHistory(() => this.insertSelectedCharm(position));
                }
                let footSide = position.getAttribute('data-foot-side');
                let charmPosition = position.getAttribute('data-position');
                let allCharmPosition = Array.from(this.charms).filter(charm => charm.getAttribute('data-foot-side') === footSide);

                let charmReq = this.activeCharm ? this.activeCharm.getAttribute('data-position-required') : null;
                
                // Logic 3 Redirect
                if (charmReq == "3") {
                    let index = parseInt(position.getAttribute('data-position-index'));
                    let redirectMap = {
                        "2": "1", "3": "1",
                        "6": "5", "7": "5",
                        "9": "8", "10": "8",
                        "13": "12", "14": "12"
                    };
                    let primaryIndex = redirectMap[index];
                    if (primaryIndex) {
                        position = this.querySelector(`.js-charm-positions[data-position-index="${primaryIndex}"]`);
                    }
                }

                if (!position) return;
                charmPosition = position.getAttribute('data-position');

                if(!this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.add('hidden');

                let charm = this.querySelector(`.js-prod-charms[data-position="${charmPosition}"]`);
                if (!charm) return;

                let charmPositionReq = position.getAttribute('data-space-required');
                if(charmPositionReq == "4") {
                    if(charm.classList.contains('js-charms-added')) return;
                    this.insertBiggerCharm(position);
                    return;
                }

                let charmImagePosition = charm.getAttribute("data-charm-prop");
                let CharmVariantName = charm.getAttribute("data-charm-name");
                let charmVariantId = charm.getAttribute("data-charm-id");
                let charmVariantPrice = charm.getAttribute("data-charm-price");
                let charmRotation = parseInt(charm.getAttribute("data-rotation")) || 0;

                this.charmsProductID = this.charmsProductID.filter(entry => {
                    let { position: pos, name, id, price } = this.parseCharmEntry(entry);
                    return !(
                        pos === charmImagePosition &&
                        name === CharmVariantName &&
                        id === charmVariantId &&
                        price === charmVariantPrice
                    );
                });

                this.charmsProductID.push(`${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                if(charm.classList.contains('js-charms-added')) return;

                allCharmPosition.forEach(container => {
                    if (container !== charm && !container.classList.contains('js-charms-added')) {
                        container.src = '';
                        container.style.opacity = '0.3';
                        container.style.cursor = 'default';
                        container.removeAttribute("data-charm-id");
                        container.removeAttribute("data-charm-price");
                        container.removeAttribute("data-charm-name");
                    }
                });

                charm.style.opacity = '1';
                charm.style.cursor = 'pointer';
                charm.classList.add('js-charms-added');
                position.classList.add('js-is-not-empty');

                let imageSrc = charm.getAttribute('src');

                let charmProp = charm.getAttribute('data-charm-prop');
                if (charmProp) {
                    let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                    if (mainImageElement) {
                        mainImageElement.src = imageSrc;
                    }
                }

                if (charmPositionReq == "2") {
                    let pairMap = {
                        "1": "2",
                        "3": "2",
                        "5": "6",
                        "7": "6",
                        "8": "9",
                        "10": "9",
                        "12": "13",
                        "14": "13"
                    };
                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndex = pairMap[placePosition];
                    if (mappedIndex) {
                        let positionToFilled = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                        let charmToFilled = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                        if (charmToFilled && positionToFilled) {
                            charmToFilled.classList.add('js-charms-added');
                            positionToFilled.classList.remove('js-is-empty');
                            positionToFilled.classList.add('js-is-not-empty');
                            positionToFilled.classList.add(`js-double-spaced-charm-${placePosition}`);
                        }
                    }
                }

                if (charmPositionReq == "3") {
                    let tripleMap = {
                        "1": ["2", "3"],
                        "5": ["6", "7"],
                        "8": ["9", "10"],
                        "12": ["13", "14"]
                    };
                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndices = tripleMap[placePosition];
                    if (mappedIndices) {
                        mappedIndices.forEach(mappedIndex => {
                            let positionToFilled = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                            let charmToFilled = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                            if (charmToFilled && positionToFilled) {
                                charmToFilled.classList.add('js-charms-added');
                                positionToFilled.classList.remove('js-is-empty');
                                positionToFilled.classList.add('js-is-not-empty');
                                positionToFilled.classList.add(`js-triple-spaced-charm-${placePosition}`);
                            }
                        });
                    }
                }

                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.classList.add('js-is-empty');
                        position.removeAttribute('data-space-required');
                    }
                })

                this.handleTotalPrice();
                this.refreshCharmPlacementPreviews();
            }

            insertBiggerCharm(position) {
                const footSide = position.getAttribute('data-foot-side');
                const group = this.getCanonicalFourSlotGroup(footSide);
                let charmSelector = `[data-position="${group.anchor?.getAttribute('data-position')}"]`;

                let charm = this.querySelector(`.js-prod-charms${charmSelector}`);
                if (charm) {
                    let charmImagePosition = charm.getAttribute("data-charm-prop");
                    let CharmVariantName = charm.getAttribute("data-charm-name");
                    let charmVariantId = charm.getAttribute("data-charm-id");
                    let charmVariantPrice = charm.getAttribute("data-charm-price");
                    let charmRotation = 0;

                    charm.style.opacity = '1';
                    charm.style.cursor = 'pointer';
                    charm.classList.add('js-charms-added', 'charm-bigger-image');

                    this.charmsProductID.push(`${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                    let charmProp = charm.getAttribute('data-charm-prop');
                    let imageSrc = charm.getAttribute('src');
                    if (charmProp && imageSrc) {
                        let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                        if (mainImageElement) {
                            mainImageElement.src = imageSrc;
                            mainImageElement.classList.add('charm-bigger-image');
                        }
                    }
                }

                group.positions.forEach(pos => {
                    pos.classList.remove('js-is-empty');
                    pos.classList.add('js-is-not-empty');
                });

                group.indices.map(index => Array.from(this.charms)[index - 1]).filter(Boolean).forEach(char => {
                    if (!char.classList.contains('js-charms-added')) {
                        char.classList.add('js-charms-added');
                        char.style.cursor = 'pointer';
                    }
                });

                this.handleTotalPrice();
                this.refreshCharmPlacementPreviews();
            }

            removeSelectedCharm(position) {
                if (!this._historyMutationDepth && !this.isRestoringHistory) {
                    return this.mutateWithHistory(() => this.removeSelectedCharm(position));
                }
                position = this.getPrimaryCharmPosition(position);
                if (!position) return;
                let footSide = position.getAttribute('data-foot-side');
                let charmPosition = position.getAttribute('data-position');
                let allCharmPosition = Array.from(this.charms).filter(charm => charm.getAttribute('data-foot-side') === footSide);

                if(!this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.add('hidden');

                let charm = this.querySelector(`.js-prod-charms[data-position="${charmPosition}"]`);
                allCharmPosition.forEach(container => {
                    if (container !== charm && !container.classList.contains('js-charms-added')) {
                        container.src = '';
                        container.style.opacity = '0.3';
                        container.style.cursor = 'default';
                        container.removeAttribute("data-charm-id");
                        container.removeAttribute("data-charm-price");
                        container.removeAttribute("data-charm-name");
                    }
                });

                let charmPositionReq = position.getAttribute('data-space-required');
                if(charmPositionReq == "4") {
                    this.removeBiggerCharm(position);
                    return;
                }
  
                charm.src = '';
                charm.removeAttribute('style');
                charm.style.opacity = 0.3;
                charm.style.cursor = 'default';
                charm.classList.remove('js-charms-added');
                position.classList.remove('js-is-not-empty');
                position.classList.add('js-is-empty');

                let charmImagePosition = charm.getAttribute("data-charm-prop");
                let CharmVariantName = charm.getAttribute("data-charm-name");
                let charmVariantId = charm.getAttribute("data-charm-id");
                let charmVariantPrice = charm.getAttribute("data-charm-price");
                let charmRotation = parseInt(charm.getAttribute("data-rotation")) || 0;
                
                this.charmsProductID = this.charmsProductID.filter(item => item !== `${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                charm.removeAttribute("data-charm-id");
                charm.removeAttribute("data-charm-price");
                charm.removeAttribute("data-charm-name");
                charm.removeAttribute('data-rotation');

                let charmProp = charm.getAttribute('data-charm-prop');
                if (charmProp) {
                    let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                    if (mainImageElement) {
                        mainImageElement.src = "";
                        mainImageElement.removeAttribute('style');
                        mainImageElement.removeAttribute('data-rotation');
                    }
                }

                if (charmPositionReq == "2") {
                    let pairMap = {
                        "1": "2",
                        "3": "2",
                        "5": "6",
                        "7": "6",
                        "8": "9",
                        "10": "9",
                        "12": "13",
                        "14": "13"
                    };

                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndex = pairMap[placePosition];

                    if (mappedIndex) {
                        let positionToClear = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                        let charmToClear = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                        if (positionToClear && charmToClear) {
                            positionToClear.classList.remove(`js-double-spaced-charm-${placePosition}`);
                            let hasCharmClass = Array.from(positionToClear.classList).some(cls => cls.startsWith('js-double-spaced-charm'));
                            if(!hasCharmClass) {
                                positionToClear.classList.remove('js-is-not-empty');
                                positionToClear.classList.add('js-is-empty');
                                charmToClear.classList.remove('js-charms-added');
                            }
                        }
                    }
                }

                if (charmPositionReq == "3") {
                    let tripleMap = {
                        "1": ["2", "3"],
                        "5": ["6", "7"],
                        "8": ["9", "10"],
                        "12": ["13", "14"]
                    };

                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndices = tripleMap[placePosition];

                    if (mappedIndices) {
                        mappedIndices.forEach(mappedIndex => {
                            let positionToClear = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                            let charmToClear = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                            if (positionToClear && charmToClear) {
                                positionToClear.classList.remove(`js-triple-spaced-charm-${placePosition}`);
                                let hasCharmClass = Array.from(positionToClear.classList).some(cls => cls.startsWith('js-triple-spaced-charm'));
                                if(!hasCharmClass) {
                                    positionToClear.classList.remove('js-is-not-empty');
                                    positionToClear.classList.add('js-is-empty');
                                    charmToClear.classList.remove('js-charms-added');
                                }
                            }
                        });
                    }
                }

                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.removeAttribute('data-space-required');
                        position.classList.add('js-is-empty');
                    }
                });

                this.handleTotalPrice();
                this.refreshCharmPlacementPreviews();
            }

            removeBiggerCharm(position) {
                const footSide = position.getAttribute('data-foot-side');
                const group = this.getCanonicalFourSlotGroup(footSide);
                let charmSelector = `[data-position="${group.anchor?.getAttribute('data-position')}"]`;

                let charm = this.querySelector(`.js-prod-charms${charmSelector}`);
                if (charm) {
                    let charmImagePosition = charm.getAttribute("data-charm-prop");
                    let CharmVariantName = charm.getAttribute("data-charm-name");
                    let charmVariantId = charm.getAttribute("data-charm-id");
                    let charmVariantPrice = charm.getAttribute("data-charm-price");
                    let charmRotation = 0;
                    this.charmsProductID = this.charmsProductID.filter(item => item !== `${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                    charm.src = ''; 
                    charm.style.opacity = '0.3';
                    charm.style.cursor = 'default';
                    charm.classList.remove('js-charms-added', 'charm-bigger-image');
                    charm.removeAttribute("data-charm-id");
                    charm.removeAttribute("data-charm-price");
                    charm.removeAttribute("data-charm-name");

                    let charmProp = charm.getAttribute('data-charm-prop');
                    if (charmProp) {
                        let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                        if (mainImageElement) {
                            mainImageElement.src = "";
                            mainImageElement.classList.remove('charm-bigger-image');
                        }
                    }
                }

                group.positions.forEach(pos => {
                    if (pos.classList.contains('js-is-not-empty')) {
                        pos.classList.add('js-is-empty');
                        pos.classList.remove('js-is-not-empty');
                        pos.removeAttribute('data-space-required');
                    }
                });

                group.indices.map(index => Array.from(this.charms)[index - 1]).filter(Boolean).forEach(char => {
                    if (char.classList.contains('js-charms-added')) {
                        char.classList.remove('js-charms-added');
                        char.style.cursor = 'default';
                        char.src = '';
                        char.style.opacity = '0.3';
                    }
                });

                this.clearActiveChainSelection();
                this.handleTotalPrice();
                this.refreshCharmPlacementPreviews();
            }

            rotateSelectedCharm(position) {
                if (!this._historyMutationDepth && !this.isRestoringHistory) {
                    return this.mutateWithHistory(() => this.rotateSelectedCharm(position));
                }
                position = this.getPrimaryCharmPosition(position);
                if (!position) return;
                let charmPosition = position.getAttribute('data-position');
                let charm = this.querySelector(`.js-prod-charms[data-position="${charmPosition}"]`);
                let charmProp = charm?.getAttribute('data-charm-prop');
                if (!charm) return;
                let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                if (!mainImageElement) return;

                let currentRotation = parseInt(charm.dataset.rotation || "0");
                currentRotation += 30;

                charm.style.transform = `rotate(${currentRotation}deg)`;
                charm.style.transition = 'transform 0.3s ease';

                mainImageElement.style.transform = `rotate(${currentRotation}deg)`;
                mainImageElement.style.transition = 'transform 0.3s ease';

                charm.dataset.rotation = currentRotation;
                mainImageElement.dataset.rotation = currentRotation;

                this.charmsProductID = this.charmsProductID.map((entry) => {
                    const parsed = this.parseCharmEntry(entry);
                    if (parsed.position !== charmProp) return entry;
                    parsed.rotation = currentRotation;
                    return this.serializeCharmEntry(parsed);
                });
            }

            selectFootImage() {
                this.footButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        this.showSelectedFoot(button);
                    });
                });
            }

            showSelectedFoot(button) {
                const selectedFoot = button?.dataset?.foot;
                if (selectedFoot !== 'left' && selectedFoot !== 'right') return;

                this.leftFootImage.classList.toggle('hidden', selectedFoot !== 'left');
                this.rightFootImage.classList.toggle('hidden', selectedFoot !== 'right');
                this.footButtons.forEach(footButton => {
                    const selected = footButton === button;
                    footButton.classList.toggle('active', selected);
                    footButton.setAttribute('aria-pressed', String(selected));
                });

                this.activeCharmPosition = null;
                this.insertPopup?.classList.add('hidden');
                this.charms.forEach((charm) => {
                    if(!charm.classList.contains('js-charms-added')) {
                        charm.src = "";
                        charm.style.opacity = '0.3';
                        charm.style.cursor = 'default';
                        charm.classList.remove('charm-bigger-image');
                        charm.removeAttribute('data-charm-name');
                        charm.removeAttribute('data-charm-id');
                        charm.removeAttribute('data-charm-price');
                    }
                });
                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.classList.add('js-is-empty');
                        position.classList.remove('js-forbidden-slot');
                        position.removeAttribute('data-space-required');
                    }
                });

                this.clearActiveChainSelection();
                if (this.activeCharm
                    && !this.activeCharm.classList.contains('js-clear-charms')
                    && !this.isElementOutOfStock(this.activeCharm)) {
                    this.placeCharms(this.activeCharm);
                } else {
                    this.updateCharmPositionAvailability();
                }
            }

            bindRibbonListeners() {
                const prodRibbons = this.querySelectorAll('.js-flip-flop-ribbon');
                const soleRibbons = this.querySelectorAll('.js-sole-ribbon');
                const ribbonNameWrapper = this.querySelector('.js-ribbon-head');

                if (!prodRibbons.length || !soleRibbons.length || !ribbonNameWrapper) return;

                this.applyStockStateToSlides(prodRibbons);
                prodRibbons.forEach((ribbon) => {
                    if (ribbon.dataset.bound) return;

                    ribbon.addEventListener('click', () => {
                        if (this.isElementOutOfStock(ribbon)) return;
                        this.mutateWithHistory(() => {
                            this.querySelectorAll('.js-flip-flop-ribbon').forEach(r => {
                                r.classList.remove('active');
                                r.setAttribute('aria-pressed', 'false');
                            });
                            ribbon.classList.add('active');
                            ribbon.setAttribute('aria-pressed', 'true');

                            const ribbonName = ribbon.getAttribute('data-ribbon-variant-title');
                            const ribbonId = ribbon.getAttribute('data-ribbon-variant-id');
                            ribbonNameWrapper.innerHTML = ribbonName;

                            if (!ribbon.classList.contains('js-remove-ribbon')) {
                                const ribbonSrc = ribbon.querySelector('img')?.getAttribute('src');
                                if (ribbonSrc) {
                                    soleRibbons.forEach((soleRibbon) => {
                                        soleRibbon.src = ribbonSrc;
                                    });
                                }
                            } else {
                                soleRibbons.forEach(soleRibbon => soleRibbon.src = '');
                            }

                            this.selectProductsID = this.selectProductsID.filter(item => !item.hasOwnProperty('ribbonColor'));
                            this.selectProductsID.push({ ribbonColor: ribbonId });
                            this.handleTotalPrice();
                        });
                    });
                    ribbon.dataset.bound = 'true';
                });
            }

            selectRibbons() {
                this.bindRibbonListeners();

                const ribbonContainer = this.querySelector('.js-ribbon-grid-slider');
                if (ribbonContainer && !ribbonContainer.dataset.bound) {
                    ribbonContainer.addEventListener('mouseleave', () => {
                        this.querySelector('.js-charm-img-zoom')?.classList.add('hidden');
                    });
                    ribbonContainer.dataset.bound = 'true';
                }
            }

            handleTotalPrice() {
                let totalPriceWrapper = this.querySelectorAll('.js-total-price');

                let solePriceItem = this.selectProductsID.find(item => 'soleColorPrice' in item);
                let strapPriceItem = this.selectProductsID.find(item => 'strapColorPrice' in item);

                let activeRibbon = this.querySelector('.js-flip-flop-ribbon.active');
                let ribbonPrice = activeRibbon?.getAttribute('data-ribbon-variant-price');

                let total = 0;
                if (solePriceItem) total += solePriceItem.soleColorPrice;
                if (strapPriceItem) total += strapPriceItem.strapColorPrice;
                if (this.charmsProductID.length > 0) {
                    this.charmsProductID.forEach(entry => {
                        const { price } = this.parseCharmEntry(entry);
                        total += parseInt(price) || 0;
                    });
                }
                if (ribbonPrice) total += parseInt(ribbonPrice);
                
                totalPriceWrapper.forEach(wrapper => {
                    wrapper.textContent = Shopify.formatMoney(total);
                });
            }

            handleAddToCartTab() {
                const config = this.buildBundleConfiguration();
                const reviewSize = this.querySelector('.js-review-size');
                const reviewProducts = this.querySelector('.js-review-products');
                if (!reviewProducts) return;

                if (reviewSize) reviewSize.textContent = config.size;
                reviewProducts.replaceChildren();

                const renderProduct = ({ type, title, detail = '', image = '', images = [], color = '', price = 0 }) => {
                    const row = document.createElement('div');
                    row.className = 'review-product';
                    const media = document.createElement('div');
                    media.className = 'review-product-media';
                    const productImages = images.filter(Boolean);
                    if (productImages.length) {
                        media.classList.add('review-product-media--pair');
                        productImages.forEach((source) => {
                            const img = document.createElement('img');
                            img.src = source;
                            img.alt = '';
                            media.appendChild(img);
                        });
                    } else if (image) {
                        const img = document.createElement('img');
                        img.src = image;
                        img.alt = '';
                        media.appendChild(img);
                    } else {
                        media.style.backgroundColor = color || '#f4f2ef';
                    }
                    const copy = document.createElement('div');
                    copy.className = 'review-product-copy';
                    const category = document.createElement('span');
                    category.className = 'review-product-type';
                    category.textContent = type;
                    const name = document.createElement('strong');
                    name.textContent = title;
                    copy.append(category, name);
                    if (detail) {
                        const meta = document.createElement('span');
                        meta.className = 'review-product-detail';
                        meta.textContent = detail;
                        copy.appendChild(meta);
                    }
                    const amount = document.createElement('span');
                    amount.className = 'review-product-price';
                    amount.textContent = Shopify.formatMoney(price);
                    row.append(media, copy, amount);
                    reviewProducts.appendChild(row);
                };

                const solePrice = this.selectProductsID.find(item => 'soleColorPrice' in item)?.soleColorPrice || 0;
                const strapPrice = this.selectProductsID.find(item => 'strapColorPrice' in item)?.strapColorPrice || 0;
                renderProduct({
                    type: 'Base',
                    title: `${config.sole.name} + ${config.strap.name}`,
                    detail: `Size ${config.size}`,
                    images: [
                        config.sole.product_image || config.sole.swatch_image,
                        config.strap.product_image || config.strap.swatch_image
                    ],
                    color: config.sole.swatch_color,
                    price: solePrice + strapPrice
                });

                const charmPrices = {};
                this.charmsProductID.forEach(entry => {
                    const charm = this.parseCharmEntry(entry);
                    if (!charmPrices[charm.name]) charmPrices[charm.name] = { price: 0, quantity: 0 };
                    charmPrices[charm.name].price += parseInt(charm.price) || 0;
                    charmPrices[charm.name].quantity += 1;
                });
                config.charms.forEach(charm => {
                    renderProduct({ type: 'Charm', title: charm.title, detail: `Quantity ${charm.quantity}`, image: charm.image, price: charmPrices[charm.title]?.price || 0 });
                });

                const activeRibbon = this.querySelector('.js-flip-flop-ribbon.active');
                const ribbonPrice = parseInt(activeRibbon?.getAttribute('data-ribbon-variant-price')) || 0;
                if (config.ribbon) {
                    renderProduct({ type: 'Ribbon pair', title: config.ribbon.title, detail: `Quantity ${config.ribbon.quantity}`, image: config.ribbon.image, price: ribbonPrice });
                }

            }

            applyFilters() {
                let activeFilterButtons = this.querySelectorAll('.js-filter.active');
                let charmsDataScript = this.querySelector(".js-charms-data");

                if (!charmsDataScript || (this.dataset.charmsCollection && !this._charmsCatalogLoaded)) return;

                let charmsData = JSON.parse(charmsDataScript.textContent);

                let activeFilters = Array.from(activeFilterButtons).map(btn =>
                    btn.getAttribute('data-filter')
                );
                let searchQuery = (this.querySelector('.js-charm-search')?.value || '').trim().toLowerCase();

                Object.entries(charmsData).forEach(([key, charmHTML]) => {
                    let tempWrapper = document.createElement('div');
                    tempWrapper.innerHTML = charmHTML;
                    let slide = tempWrapper.firstElementChild;
                    if (!slide) return;

                    let labels = slide.getAttribute('data-filter-labels') || "";
                    let labelList = labels.split(',').map(l => l.trim());

                    let matchesFilters = activeFilters.length === 0 || activeFilters.some(f => labelList.includes(f));
                    let title = (slide.getAttribute('data-charm-variant-title') || '').toLowerCase();
                    let matchesSearch = !searchQuery || title.includes(searchQuery);
                    let matches = matchesFilters && matchesSearch;

                    if (matches || key == "none--0") {
                        slide.classList.remove('hidden');
                    } else {
                        slide.classList.add('hidden');
                    }

                    charmsData[key] = tempWrapper.innerHTML;
                });

                charmsDataScript.textContent = JSON.stringify(charmsData);
                this.arrangeCharms();
            }

            getRibbonQuantityPerBundle() {
                return 2;
            }

            buildBundleConfiguration() {
                const normalizeUrl = (url) => {
                    if (!url) return '';
                    if (url.startsWith('//')) return `https:${url}`;
                    return url;
                };

                const config = {
                    size: '',
                    mainImage: '',
                    sole: { name: '', swatch_image: '', swatch_color: '', product_image: '' },
                    strap: { name: '', swatch_image: '', swatch_color: '', product_image: '' },
                    ribbon: null,
                    charms: []
                };

                const selectedSizeRaw = this.flipFlopSize?.value || '';
                const selectedSize = selectedSizeRaw.split('-')[0] || selectedSizeRaw;
                config.size = selectedSize;

                const lookupVariantData = (data, scriptKey, colorHandle) => {
                    if (!data) return null;
                    if (data[scriptKey]) return data[scriptKey];
                    if (!colorHandle) return null;
                    for (const key in data) {
                        if (key.includes(colorHandle)) return data[key];
                    }
                    return null;
                };

                const soleScript = this.querySelector('.js-sole-color-product');
                if (this.activeSole && soleScript) {
                    const soleData = JSON.parse(soleScript.textContent);
                    const colorHandle = this.activeSole.getAttribute('data-sole-color-name');
                    const scriptKey = `${selectedSize}-${colorHandle}`;
                    const variantData = lookupVariantData(soleData, scriptKey, colorHandle);
                    if (variantData) {
                        config.mainImage = normalizeUrl(variantData.mainImage || '');
                        config.sole = {
                            name: this.soleColorName?.innerHTML?.trim() || '',
                            swatch_image: normalizeUrl(variantData.swatch_image || ''),
                            swatch_color: variantData.swatch_color || '',
                            product_image: normalizeUrl(variantData.left_sole_side || '')
                        };
                    }
                }

                const strapScript = this.querySelector('.js-strap-color-product');
                if (this.activeStrap && strapScript) {
                    const strapData = JSON.parse(strapScript.textContent);
                    const sizeMapping = this.getStrapSizeMapping();
                    const strapSize = sizeMapping[selectedSize] || selectedSize;
                    const colorHandle = this.activeStrap.getAttribute('data-strap-color-name');
                    const scriptKey = `${strapSize}-${colorHandle}`;
                    const variantData = lookupVariantData(strapData, scriptKey, colorHandle);
                    if (variantData) {
                        config.strap = {
                            name: this.strapColorName?.innerHTML?.trim() || '',
                            swatch_image: normalizeUrl(variantData.swatch_image || ''),
                            swatch_color: variantData.swatch_color || '',
                            product_image: normalizeUrl(variantData.left_strap_side || '')
                        };
                    }
                }

                const ribbonScript = this.querySelector('.js-ribbon-cart-data');
                const activeRibbon = this.querySelector('.js-flip-flop-ribbon.active');
                if (activeRibbon && ribbonScript) {
                    const ribbonTitle = activeRibbon.getAttribute('data-ribbon-variant-title');
                    if (ribbonTitle && ribbonTitle !== 'No ribbon') {
                        const ribbonData = JSON.parse(ribbonScript.textContent);
                        let ribbonEntry = null;
                        for (const key in ribbonData) {
                            if (ribbonData[key].title === ribbonTitle) {
                                ribbonEntry = ribbonData[key];
                                break;
                            }
                        }
                        if (ribbonEntry) {
                            config.ribbon = {
                                title: ribbonEntry.title,
                                image: normalizeUrl(ribbonEntry.image || ''),
                                quantity: this.getRibbonQuantityPerBundle()
                            };
                        }
                    }
                }

                const charmScript = this.querySelector('.js-charm-cart-data');
                if (this.charmsProductID.length > 0 && charmScript) {
                    const charmData = JSON.parse(charmScript.textContent);
                    const charmCounts = {};
                    const charmOrder = [
                        'left-c1','left-c2','left-c3','left-c4','left-c5','left-c6','left-c7',
                        'right-c1','right-c2','right-c3','right-c4','right-c5','right-c6','right-c7'
                    ];

                    this.charmsProductID.forEach(charm => {
                        const { position, name, id } = this.parseCharmEntry(charm);
                        if (!charmCounts[id]) {
                            charmCounts[id] = {
                                title: name,
                                image: normalizeUrl(charmData[id]?.image || ''),
                                quantity: 0,
                                firstPosition: position
                            };
                        }
                        charmCounts[id].quantity += 1;
                    });

                    config.charms = Object.values(charmCounts).sort(
                        (a, b) => charmOrder.indexOf(a.firstPosition) - charmOrder.indexOf(b.firstPosition)
                    );
                }

                return config;
            }

            buildBundleCartProperties(config) {
                const properties = {};

                if (config.size) properties._bundle_size = config.size;
                if (config.mainImage) properties._bundle_main_image = config.mainImage;

                if (config.sole?.name) properties._bundle_sole_name = config.sole.name;
                if (config.sole?.swatch_color) properties._bundle_sole_swatch_color = config.sole.swatch_color;
                if (config.sole?.swatch_image) properties._bundle_sole_swatch_image = config.sole.swatch_image;

                if (config.strap?.name) properties._bundle_strap_name = config.strap.name;
                if (config.strap?.swatch_color) properties._bundle_strap_swatch_color = config.strap.swatch_color;
                if (config.strap?.swatch_image) properties._bundle_strap_swatch_image = config.strap.swatch_image;

                if (config.ribbon?.title) {
                    properties._bundle_ribbon_title = config.ribbon.title;
                    properties._bundle_ribbon_image = config.ribbon.image || '';
                    properties._bundle_ribbon_quantity = String(config.ribbon.quantity || 2);
                }

                if (config.charms?.length > 0) {
                    properties._bundle_charms = config.charms.map((charm) => {
                        const qty = charm.quantity || 1;
                        const title = charm.title || '';
                        const image = charm.image || '';
                        return `${qty}:::${title}:::${image}`;
                    }).join('|||');
                }

                return properties;
            }

            handleBundleAddToCart() {
                if (!this.flipFlopSize?.value) {
                    this.activateStep(0);
                    this.showStepMessage('Choose your size before adding this design to cart.');
                    return;
                }

                let now = new Date();
                let currentTime = now.getTime();
                let bundleConfiguration = this.buildBundleConfiguration();
                const ribbonPerBundle = bundleConfiguration.ribbon?.quantity || this.getRibbonQuantityPerBundle();

                let get = key => this.selectProductsID.find(obj => key in obj)?.[key];
                if (!get('soleColor') || !get('strapColor')) {
                    this.activateStep(0);
                    this.showStepMessage('This size and color combination is unavailable. Please choose another option.');
                    return;
                }

                const actionButtons = Array.from(this.querySelectorAll('.js-bundle-add-to-cart, .js-step-next'))
                    .filter(button => !button.hidden);
                const originalLabels = actionButtons.map(button => button.textContent);
                actionButtons.forEach(button => {
                    button.disabled = true;
                    button.setAttribute('aria-busy', 'true');
                    button.textContent = 'Adding…';
                });
                this.clearStepMessage();

                let items = [];

                items.push({
                    id: get('soleColor'),
                    quantity: 1,
                    properties: {
                        _is_flop_flop_bundle_prod: 'true',
                        _main_bundle_id: currentTime,
                        ...this.buildBundleCartProperties(bundleConfiguration)
                    }
                });

                ['strapColor', 'ribbonColor'].forEach(key => {
                    let id = get(key);
                    if (id) {
                        let item = {
                            id: id,
                            quantity: key === 'ribbonColor' ? ribbonPerBundle : 1,
                            properties: { 
                                _is_flop_flop_bundle_prod: 'true',
                                [`_bundle_${key.toLowerCase()}_product`]: 'true',
                                _sub_product_bundle_id: currentTime
                            }
                        };
                        items.push(item);
                    }
                });

                if (this.charmsProductID.length > 0) {
                    this.charmsProductID.forEach(charm => {
                        let { position, id, rotation } = this.parseCharmEntry(charm);
                        items.push({
                            id,
                            quantity: 1,
                            properties: {
                                _sub_product_bundle_id: currentTime,
                                _is_flop_flop_bundle_prod: 'true',
                                _bundle_charm_product: 'true',
                                _bundle_product_position: position,
                                _bundle_product_angle: `${rotation % 360} degree`
                            }
                        });
                    });
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                })
                .then(async (response) => {
                    if (response.ok) {
                        this.undoHistory = [];
                        this._lastCommittedState = null;
                        this.updateUndoControl();
                        window.location.href = '/cart';
                    } else {
                        let err = await response.json();
                        console.error('Failed to add to cart:', response.status, err);
                        throw new Error(err.description || 'Unable to add this design to cart.');
                    }
                })
                .catch(err => {
                    console.error('Cart error:', err);
                    this.showStepMessage(err.message || 'Unable to add this design to cart. Please try again.');
                    actionButtons.forEach((button, index) => {
                        button.disabled = false;
                        button.removeAttribute('aria-busy');
                        button.textContent = originalLabels[index];
                    });
                });
            }

            resetBundleWarning() {
                let warningPopup = this.querySelector('.js-reset-warning-popup');
                this.openModal(warningPopup);
            }

            resetBundle() {
                this.isRestoringHistory = true;
                this.resetShoeZoom();
                this.flipFlopSize.value = '';
                this.sizeButtons.forEach(button => {
                    button.classList.remove('active');
                    button.setAttribute('aria-pressed', 'false');
                });
                this.footButtons.forEach((button, index) => {
                    button.classList.toggle('active', index === 0);
                    button.setAttribute('aria-pressed', String(index === 0));
                });
                this.leftFootImage?.classList.remove('hidden');
                this.rightFootImage?.classList.add('hidden');
                this.activateStep(0);
                this.soleColors.forEach(option => {
                    option.classList.remove('active-color', 'hidden', 'is-out-of-stock');
                    option.setAttribute('aria-pressed', 'false');
                    option.setAttribute('aria-disabled', 'false');
                    option.setAttribute('data-out-of-stock', 'false');
                });
                this.strapColors.forEach(option => {
                    option.classList.remove('active-color', 'hidden', 'is-out-of-stock');
                    option.setAttribute('aria-pressed', 'false');
                    option.setAttribute('aria-disabled', 'false');
                    option.setAttribute('data-out-of-stock', 'false');
                });
                this.activeSole = null;
                this.activeStrap = null;
                if (this.soleColorName) this.soleColorName.textContent = '';
                if (this.strapColorName) this.strapColorName.textContent = '';
                this.selectProductsID = this.selectProductsID.filter(
                    item => !('soleColor' in item || 'soleColorPrice' in item || 'strapColor' in item || 'strapColorPrice' in item || 'strapSize' in item)
                );
                this.initializeBasePlaceholder();
                this.initializeSoleSlider('js-sole-slider', 1);
                this.initializeSoleSlider('js-strap-slider', 2);
                this.initializeDefaultBaseSelections();

                let prodRibbons = this.querySelectorAll('.js-flip-flop-ribbon');
                let clearRibbon = this.querySelector('.js-remove-ribbon');
                let soleRibbons = this.querySelectorAll('.js-sole-ribbon');
                let ribbonNameWrapper = this.querySelector('.js-ribbon-head');

                let ribbonName = clearRibbon.getAttribute('data-ribbon-variant-title');
                let ribbonId = clearRibbon.getAttribute('data-ribbon-variant-id');
                ribbonNameWrapper.innerHTML = ribbonName;

                prodRibbons.forEach(r => {
                    r.classList.remove('active');
                    r.setAttribute('aria-pressed', 'false');
                });
                clearRibbon.classList.add('active');
                clearRibbon.setAttribute('aria-pressed', 'true');

                soleRibbons.forEach(soleRibbon => soleRibbon.src = '');
                this.selectProductsID = this.selectProductsID.filter(item => !item.hasOwnProperty('ribbonColor'));
                this.selectProductsID.push({ ribbonColor: ribbonId });

                this.clearCharms();
                this.clearStepMessage();
                this.updateStepNavigation();
                this.isRestoringHistory = false;
                this.initializeHistory();
            }

            initializeSoleSlider(className, options) {
                if (this[`soleSlider_${options}`]) {
                    this[`soleSlider_${options}`].destroy(true, true);
                }
                const sliderElement = this.querySelector(`.${className}`);
                if (!sliderElement) return;
                const slides = Array.from(sliderElement.querySelectorAll('.swiper-slide:not(.hidden)'));
                const selectedIndex = slides.findIndex(slide =>
                    slide.classList.contains('active-color') || slide.classList.contains('active-strap')
                );
                const activeIndex = selectedIndex >= 0
                    ? selectedIndex
                    : Math.max(0, Math.floor((slides.length - 1) / 2));
                this[`soleSlider_${options}`] = new SwiperV11(sliderElement, {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 0,
                    initialSlide: activeIndex,
                    loop: false,
                    freeMode: true,
                    centeredSlides: true,
                    centeredSlidesBounds: false,
                    watchOverflow: false
                });
            }

            initializeMobileSoleSlider(className, options) {
                if (this[`soleMobileSlider_${options}`]) {
                    this[`soleMobileSlider_${options}`].destroy(true, true);
                }
                this[`soleMobileSlider_${options}`] = new SwiperV11(`.${className}`, {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                    loop: false,
                    breakpoints: {
                        320: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                            grid: {
                                rows: 2,
                                fill: 'row'
                            },
                        },
                        500: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                            grid: {
                                rows: 3,
                                fill: 'row'
                            },
                        },
                        751: {
                            slidesPerView: 6,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                });
            }

            charmsSlider(className, options) {
                if (this[`gridSlider_${options}`]) {
                    this[`gridSlider_${options}`].destroy(true, true);
                }
                const sliderElement = this.querySelector(`.${className}`);
                if (!sliderElement) return;
                this[`gridSlider_${options}`] = new SwiperV11(sliderElement, {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    loop: false,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                    breakpoints: {
                        751: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                            grid: {
                                rows: 3,
                                fill: 'row'
                            },
                        },
                        500: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                            grid: {
                                rows: 3,
                                fill: 'row'
                            },
                        },
                        320: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                            grid: {
                                rows: 2,
                                fill: 'row'
                            },
                        }
                    },
                    navigation: {
                        nextEl: sliderElement.querySelector('.swiper-button-next'),
                        prevEl: sliderElement.querySelector('.swiper-button-prev')
                    },
                });
            }

        }
    );
}